// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../public/SiteIcons/listLocatiionPin.svg");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SaveCalendar-errorMessage-gKG3f {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}
.SaveCalendar-space1-tD9QG {
	margin-bottom: 6px !important;
}
.SaveCalendar-space2-EyXsY {
	margin-bottom: 12px !important;
}
.SaveCalendar-space3-d4EYA {
	margin-bottom: 18px !important;
}
.SaveCalendar-space4-z9fue {
	margin-bottom: 24px !important;
}
.SaveCalendar-space5-l9CPK {
	margin-bottom: 30px !important;
}
.SaveCalendar-space6-ulQEm {
	margin-bottom: 36px !important;
}
.SaveCalendar-space7-tgDI9 {
	margin-bottom: 42px !important;
}
.SaveCalendar-spaceTop8-WpJKF {
	margin-bottom: 48px !important;
}
.SaveCalendar-spaceTop1-c9EzL {
	margin-top: 6px !important;
}
.SaveCalendar-spaceTop2-cosGs {
	margin-top: 12px !important;
}
.SaveCalendar-spaceTop3-n3jRv {
	margin-top: 18px !important;
}
.SaveCalendar-spaceTop4-k0Qgg {
	margin-top: 24px !important;
}
.SaveCalendar-spaceTop5-diYPC {
	margin-top: 30px !important;
}
.SaveCalendar-spaceTop6-vWoAo {
	margin-top: 36px !important;
}
.SaveCalendar-spaceTop7-xFwZW {
	margin-top: 42px !important;
}
.SaveCalendar-spaceTop8-WpJKF {
	margin-top: 48px !important;
}
.SaveCalendar-noMargin-y6Pe7 {
	margin: 0px !important;
}
.SaveCalendar-padding1-H5qkr {
	padding-bottom: 6px !important;
}
.SaveCalendar-padding2-JIhcD {
	padding-bottom: 12px !important;
}
.SaveCalendar-padding3-w8VYr {
	padding-bottom: 18px !important;
}
.SaveCalendar-padding4-Cad9j {
	padding-bottom: 24px !important;
}
.SaveCalendar-padding5-fH28s {
	padding-bottom: 30px !important;
}
.SaveCalendar-padding6-vIgKg {
	padding-bottom: 36px !important;
}
.SaveCalendar-padding7-pGled {
	padding-bottom: 42px !important;
}
.SaveCalendar-paddingTop1-oAaEI {
	padding-top: 6px !important;
}
.SaveCalendar-paddingTop2-hqyKk {
	padding-top: 12px !important;
}
.SaveCalendar-paddingTop3-M6Pqm {
	padding-top: 18px !important;
}
.SaveCalendar-paddingTop4-CvtpU {
	padding-top: 24px !important;
}
.SaveCalendar-paddingTop5-tR2fT {
	padding-top: 30px !important;
}
.SaveCalendar-paddingTop6-FbF5b {
	padding-top: 36px !important;
}
.SaveCalendar-paddingTop7-B2RWU {
	padding-top: 42px !important;
}
.SaveCalendar-noPadding-nt7Pt {
	padding: 0px !important;
}
.SaveCalendar-textBold-Pdw2_ {
	font-weight: 500 !important;
}
.SaveCalendar-textBolder-N1aIw {
	font-weight: 700 !important;
}
.SaveCalendar-textNormal-TB4OB {
	font-weight: normal !important;
}
.SaveCalendar-spaceBottom20-sewfH {
	margin-bottom: 20px;
}
.SaveCalendar-spaceBottom10-LYSTT {
	margin-bottom: 10px;
}
.SaveCalendar-marginNone-x2C2d {
	margin: 0;
}
.SaveCalendar-spaceBottom15-yShX5 {
	margin-bottom: 15px;
}
.SaveCalendar-marginTopNone-mOMuo {
	margin-top: 0;
}
.SaveCalendar-spaceTop11-fNFRq {
	margin-top: 11px;
}
.SaveCalendar-spaceTop21-Cc6Wy {
	margin-top: 21px;
}
.SaveCalendar-spaceTop20-n7IcT {
	margin-top: 20px;
}
.SaveCalendar-spaceTop10-Ti7n7 {
	margin-top: 10px;
}
/*New Design Text Colors */
.SaveCalendar-textDarkBlue-mcQhN {
	color: rgb(20, 39, 94) !important;
}
.SaveCalendar-textLightBlue-ZFVM8 {
	color: rgb(57, 87, 106) !important;
}
.SaveCalendar-textLightSandleGreen-mjtY4 {
	color: rgb(76, 86, 41) !important;
}
.SaveCalendar-textLightBrown-AoxRY {
	color: rgb(115, 79, 33) !important;
}
.SaveCalendar-textMediumMaroon-F8zRS {
	color: rgb(87, 37, 51) !important;
}
.SaveCalendar-textBrown-A4_v4 {
	color: rgb(160, 47, 24) !important;
}
.SaveCalendar-textMaroon-ifcnX {
	color: rgb(155, 49, 67) !important;
}
.SaveCalendar-textDarkBrown-PxfPQ {
	color: rgb(83, 18, 16) !important;
}
.SaveCalendar-textMediumBrown-_CZB1 {
	color: rgb(142, 28, 10) !important;
}
.SaveCalendar-textSkyBlue-Mu6P8 {
	color: rgb(37, 117, 141) !important;
}
.SaveCalendar-textGray-qsq4b {
	color: rgb(77, 65, 51) !important;
}
/* Common Helpers Style - Start */
.SaveCalendar-button-_yUqu {
	font-size: 16px;
	margin-top: 15px;
}
.SaveCalendar-formGroup-tkqSn {
	margin-bottom: 6px;
}
.SaveCalendar-formControlInput-ebrXk {
	padding: 10px 35px 10px 10px;
	height: 40px;
	border-radius: 4px;
	font-size: 14px;
	border: 1px solid var(--primary-border);
	background-color: var(--primary-input-bg);
	color: var(--primary-foreground);
}
.SaveCalendar-jumboInput-TOnxx {
	font-size: 16px;
	height: 58px;
	padding: 0px 20px;
	border-color: var(--primary-border) !important;
	vertical-align: middle;
	border-width: 1px !important;
}
.SaveCalendar-textareaInput-fOy3M {
	height: 230px !important;
	border: solid 1px var(--primary-border);
	padding: 20px;
	font-size: 16px;
	border-radius: 4px;
	resize: none;
}
.SaveCalendar-formControlSelect-ERpb5 {
	padding: 10px 32px 10px 10px;
	border-radius: 4px;
	font-size: 14px;
	border: 1px solid var(--primary-border);
	background-color: var(--primary-input-bg);
	color: var(--primary-foreground);
	max-width: 100%;
	/* Drop Down Caret Icon*/
	-webkit-appearance: none;
	   -moz-appearance: none;
	        appearance: none;
	background-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%);
	background-position: calc(100% - 20px) 17px, calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;
	background-size: 5px 6px, 5px 6px, 1px 1.5em;
	background-repeat: no-repeat;
	-webkit-box-shadow: none;
	box-shadow: none;
	/*Drop Down Caret Icon */
}
.SaveCalendar-formControlSelectLarge-msXQI {
	max-width: 100%;
}
.SaveCalendar-select-Vnfiy {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
}
.SaveCalendar-blockRadioButton-u1CC8 {
	margin-top: 0;
	max-width: 320px;
}
.SaveCalendar-formSection-F_35J {
	overflow: hidden;
}
.SaveCalendar-landingContainer-autrm {
	max-width: 912px;
	width: 100%;
	display: block;
	margin: 0 auto;
}
.SaveCalendar-landingTitle-kXPXZ {
	font-size: 32px;
	margin: 0px 0px 30px 0px;
}
.SaveCalendar-landingStep-TVbfs {
	font-size: 14px;
	color: var(--secondary-foreground);
	font-weight: bold;
	margin: 0px 0px 6px 0px;
}
.SaveCalendar-landingStep2-oVtJx {
	font-size: 18px;
	color: var(--secondary-foreground);
	margin: 0px 0px 10px 0px;
	display: block;
}
.SaveCalendar-landingStep3-ia8O6 {
	font-size: 16px;
	color: var(--secondary-foreground);
	line-height: 1.43;
	font-weight: normal;
}
.SaveCalendar-landingContent-I0AiT {
	margin-top: 60px;
	padding-bottom: 100px;
}
.SaveCalendar-landingMainContent-vJsat {
	height: auto;
	padding: 50px 45px 200px;
	overflow-y: auto;
}
.SaveCalendar-landingLabel-W9uOO {
	font-size: 18px !important;
	display: block;
	padding: 0px 0px 12px;
	margin: 0px !important;
	font-weight: 500 !important;
}
.SaveCalendar-bookingTitle-oaAAA {
	margin: 0px;
	word-wrap: break-word;
	font-size: 28px;
	line-height: 36px;
	letter-spacing: -0.6px;
	padding-top: 2px;
	padding-bottom: 2px;
}
.SaveCalendar-bookText-hja0z {
	font-size: 16px;
	font-weight: normal;
}
.SaveCalendar-radioInput-hNQmy {
	position: relative;
	height: 1.25em;
	width: 1.25em;
	margin-right: 10px !important;
	vertical-align: top;
}
.SaveCalendar-radioSize-HwcKn {
	height: 15px;
	width: 15px
}
.SaveCalendar-checkboxLabel-mLPg5 {
	font-weight: normal;
	display: inline;
	padding: 0px 10px;
	margin: 0px;
	line-height: 20px;
	vertical-align: middle;
	word-break: break-word;
}
.SaveCalendar-landingCaption-Fa2Kl {
	color: var(--secondary-foreground);
	font-size: 16px;
	margin-bottom: 5px;
	margin-top: 30px;
}
.SaveCalendar-listContainer-J9Qgw {
	padding: 0px;
	list-style-type: none;
}
.SaveCalendar-listContent-ITJHT {
	margin-bottom: 30px;
	font-size: 16px;
	width: 50%;
	display: inline-block;
	vertical-align: top !important;
}
.SaveCalendar-horizontalLineThrough-XEEJW {
	position: relative;
	z-index: 1;
	display: block;
	margin: 15px 0px;
	width: 100%;
	color: var(--primary-border);
	text-align: center;
	font-size: 14px;
}
.SaveCalendar-blockRadioButton-u1CC8 {
	margin-top: 0;
	max-width: 320px;
	border: 1px solid var(--primary-border);
	padding: 20px;
}
.SaveCalendar-blockRadioButton-u1CC8:first-of-type {
	border-radius: 3px 3px 3px 3px;
}
.SaveCalendar-blockRadioButton-u1CC8:last-of-type {
	border-radius: 0px 0px 3px 3px;
}
.SaveCalendar-blockRadioButton-u1CC8:not(:last-of-type) {
	border-bottom: 0px;
}
.SaveCalendar-helpPanelContainer-bWkJM {
	max-width: 320px;
}
.SaveCalendar-helpPanel-C3WL1 {
	margin: 60px 30px 0;
	border: 1px solid var(--primary-border);
	border-radius: 4px;
	width: 100%;
	padding: 26px;
	background: var(--background-primary);
}
.SaveCalendar-helpPanelText-dKIaH {
	font-size: 16px;
	line-height: 150%;
	color: var(--secondary-foreground);
	word-break: break-word;
}
.SaveCalendar-helpPanelTextTitle-LYDgS {
	color: var(--secondary-foreground);
	display: block;
	width: 100%;
}
.SaveCalendar-incrementDecrementButton-H0MyY {
	max-width: 320px;
	width: 100%;
	border: 1px solid var(--primary-border);
	border-radius: 2px;
	display: block;
	overflow: hidden;
}
.SaveCalendar-incrementDecrementText-VpMxG {
	float: left;
	width: 80%;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	padding: 18px 20px;
	margin: 0px;
	font-size: 16px;
	color: var(--secondary-foreground);
	line-height: 1;
	vertical-align: middle;
	font-weight: normal;
	background: var(--primary-input-bg);
}
.SaveCalendar-iconButton-LDa5F {
	width: 10%;
	float: left;
	border-color: var(--primary-border);
	border-width: 0px 0px 0px 1px;
	border-radius: 0px;
	padding: 12px 20px;
	height: 65px;
	margin: 0px 0px;
	font-size: 15px;
	line-height: 1px;
	color: var(--secondary-bg);
	background: var(--primary-input-bg);
}
.SaveCalendar-iconButton-LDa5F:hover,
.SaveCalendar-iconButton-LDa5F:focus,
.SaveCalendar-iconButton-LDa5F:active {
	background: var(--background-primary) !important;
	border-color: var(--primary-border) !important;
	border-width: 0px 0px 0px 1px;
	margin-left: 0px;
	-webkit-box-shadow: none;
	        box-shadow: none;
}
.SaveCalendar-checkBoxSection-SlS_9 {
	display: table-cell;
}
.SaveCalendar-checkBoxWidth-IlPlw {
	width: 1%;
	vertical-align: top;
}
.SaveCalendar-checkBoxImage-Wphrf {
	width: 36px;
}
.SaveCalendar-checkBoxLabel-Qh_9K {
	padding: 0px 10px;
}
.SaveCalendar-textAlignRight-vayZQ {
	text-align: right;
}
.SaveCalendar-textAlignLeft-PBOq0 {
	text-align: left;
}
.SaveCalendar-textAlignCenter-VH_vs {
	text-align: center;
}
.SaveCalendar-noPadding-nt7Pt {
	padding: 0px;
}
.SaveCalendar-pullRight-sB9Sl {
	float: right;
}
.SaveCalendar-pullLeft-kbRmH {
	float: left;
}
.SaveCalendar-noMargin-y6Pe7 {
	margin: 0px;
}
.SaveCalendar-unorderedList-wgMv_ li {
	margin-bottom: 10px;
	padding: 0px;
}
.SaveCalendar-checkIcon-NWwyk {
	color: var(--secondary-bg);
	margin: 0px 10px 5px 0px;
}
.SaveCalendar-textHigh-PhyNU {
	font-size: 18px;
	line-height: 1.43;
}
.SaveCalendar-textLow-vNGDw {
	font-size: 16px;
	color: var(--secondary-foreground);
	line-height: 1.43;
}
/* Common Helpers Style - End */
/** List Photo Cover Style - Start */
.SaveCalendar-listPhotoCover-uJ1tw {
	display: block;
	height: 185px;
	-webkit-backface-visibility: hidden;
	        backface-visibility: hidden;
	position: relative;
	vertical-align: bottom;
	overflow: hidden;
	background-color: var(--secondary-gray-bg);
	text-align: center;
	margin-top: 15px;
}
.SaveCalendar-listPhotoMedia-t8sGw {
	position: absolute;
	right: 0;
	left: 0;
	bottom: 0;
	top: 0;
}
.SaveCalendar-imgResponsive-QgUuo {
	height: 100%;
	width: auto;
	max-width: 100%;
}
.SaveCalendar-coverPhotoSelection-KBkds {
	position: absolute;
	bottom: 5px;
	left: 5px;
	width: 100px;
	height: 30px;
	background: var(--primary-bg);
	color: var(--primary-foreground);
	font-size: 14px;
	border-radius: 5px 12px 12px 5px;
	line-height: 30px;
}
.SaveCalendar-coverPhotoCheckbox-vc8JZ {
	margin: 0px !important;
	vertical-align: middle;
}
/** List Photo Cover Style - End */
.SaveCalendar-landingContainer-autrm {
	max-width: 912px;
	width: 100%;
	display: block;
	margin: 0 auto;
}
.SaveCalendar-landingContent-I0AiT {
	margin-top: 60px;
	margin-bottom: 100px;
}
.SaveCalendar-noPadding-nt7Pt {
	padding: 0px;
}
.SaveCalendar-landingContentTitle-_mwTX {
	font-size: 18px;
	margin: 0 0 12px;
	position: relative;
}
.SaveCalendar-landingSaftyTitle-RA4gQ {
	font-size: 20px !important;
	margin: 0px 0px 18px 0px;
}
.SaveCalendar-bookingLandingStep-GJ76s {
	font-size: 18px;
	color: var(--secondary-foreground);
	margin: 0px 0px 10px 0px;
	display: block;
}
.SaveCalendar-horizontalLineThrough-XEEJW {
	position: relative;
	z-index: 0;
	display: block;
	margin: 0px 0px 15px;
	width: 100%;
	color: var(--primary-border);
	text-align: center;
	font-size: 14px;
	border-top: 1px solid var(--primary-border);
	-webkit-box-shadow: 0px -2px 10px var(--primary-box-shadow) !important;
	        box-shadow: 0px -2px 10px var(--primary-box-shadow) !important;
}
.SaveCalendar-BookingradioInput-L0Lf0 {
	height: 1.25em;
	width: 1.25em;
	margin-right: 5px;
	vertical-align: top;
}
.SaveCalendar-bookText-hja0z {
	font-size: 16px;
	font-weight: normal;
	margin-left: 10px;
	display: block;
}
.SaveCalendar-subText-tz5w8 {
	color: var(--secondary-foreground);
	padding-left: 10px;
	font-size: 14px;
	font-weight: normal;
	display: block;
}
.SaveCalendar-displayTable-eb_7w {
	display: table;
}
.SaveCalendar-displayTableCell-GjAwt {
	display: table-cell;
}
/** SyncCalendar Start **/
.SaveCalendar-listType-D3HVJ {
	padding-left: 0;
	list-style: none;
}
.SaveCalendar-iconContainer-vzFiT {
	cursor: pointer;
	background-color: transparent;
	border: 0px;
	display: block;
}
.SaveCalendar-iconContainer-vzFiT:active,
.SaveCalendar-iconContainer-vzFiT:focus,
.SaveCalendar-iconContainer-vzFiT:hover,
.SaveCalendar-iconContainer-vzFiT:active:focus {
	border: 0px;
	background-color: var(--background-primary);
	outline: none;
	-webkit-box-shadow: none;
	        box-shadow: none;
}
.SaveCalendar-iconSize-jxfut {
	height: 20px;
	width: 20px;
	color: var(--secondary-foreground);
}
.SaveCalendar-calenderText-j8o6u {
	font-size: 16px;
	line-height: normal;
	word-wrap: break-word;
	color: var(--primary-foreground);
	margin: 0px;
}
.SaveCalendar-LineColor-jQwgJ {
	border-top: 1px solid var(--primary-border);
}
.SaveCalendar-btnContainer-_nvcV {
	color: var(--secondary-bg);
	font-size: 18px;
	text-decoration: none;
	border: 0px;
	cursor: pointer;
	margin: 0px;
	padding: 0px;
	text-align: left;
	-webkit-user-select: auto;
	   -moz-user-select: auto;
	    -ms-user-select: auto;
	        user-select: auto;
	background: transparent;
}
.SaveCalendar-btnContainer-_nvcV:hover,
.SaveCalendar-btnContainer-_nvcV:focus,
.SaveCalendar-btnContainer-_nvcV:active,
.SaveCalendar-btnContainer-_nvcV:active:focus {
	border: 0px;
	background-color: transparent;
	outline: none;
	-webkit-box-shadow: none;
	        box-shadow: none;
	color: var(--secondary-bg);
}
.SaveCalendar-displayTableCellVertical-yBViW {
	display: table-cell;
	vertical-align: middle;
}
.SaveCalendar-paddingLeft-njBEy {
	padding-left: 8px;
}
.SaveCalendar-iconColor-ZXS9N {
	color: var(--secondary-bg);
}
.SaveCalendar-space0-M4krK {
	margin-bottom: 0px;
}
.SaveCalendar-step3IconLeft-cCsy5 {
	display: inline-block;
}
.SaveCalendar-displayTableRow-OZ814 {
	display: table-row;
	width: 100%;
}
.SaveCalendar-displayTableCellWidth-oAJm7 {
	width: 5%
}
.SaveCalendar-displayTableCellTop-Yw1o_ {
	vertical-align: top;
}
.SaveCalendar-tableWidthTwo-xNcC4 {
	width: 80%;
}
.SaveCalendar-tableWidth-SdQx5 {
	width: 5%;
}
.SaveCalendar-noFontWeight-MngMG {
	font-weight: normal;
}
.SaveCalendar-nextPosition-C_QZw {
	position: fixed;
	bottom: 0;
	width: 100%;
	background: var(--background-primary);
	z-index: 4;
	padding: 0 0px 25px;
	width: 100%;
	max-width: 644px;
	margin: 0 auto;
}
.SaveCalendar-nextPositionMap-wvNuA {
	max-width: 912px !important;
	padding-left: 15px !important;
	padding-right: 15px !important;
	left: 0;
	right: 0;
}
.SaveCalendar-nextPositionCalendar-uj5eV {
	max-width: 1170px !important;
	padding-left: 15px !important;
	padding-right: 15px !important;
	left: 0;
	right: 0;
}
.SaveCalendar-nextBackButton-d973p {
	width: 100%;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	border-top: 1px solid var(--primary-border);
	-webkit-box-shadow: 0px -7px 16px var(--primary-box-shadow);
	        box-shadow: 0px -7px 16px var(--primary-box-shadow);
	padding-top: 30px;
}
.SaveCalendar-nextBackButtonMap-Ja8Z7 {
	width: 100%;
}
.SaveCalendar-nextBackButtonCalendar-ubKUE {
	width: 100%;
}
.SaveCalendar-posRelative-cm2dK {
	position: relative;
}
.SaveCalendar-imagefeed-OQqoe {
	position: absolute;
	top: 20px;
	width: 30%;
	height: 50px;
	border: 1px solid var(--primary-border);
	padding: 7px 7px;
	border-radius: 5px;
	z-index: 3;
}
.SaveCalendar-caListimg-q_Ec2 {
	max-width: 55px;
	width: 100%;
	height: 35px;
	float: left;
	background-size: cover;
	background-position: top center;
	border-radius: 2px;
}
.SaveCalendar-caListPara-QShaf {
	float: left;
	width: 78%;
	padding: 0 0 0 10px;
}
.SaveCalendar-caListPara-QShaf h2 {
	margin: 0;
	font-size: 14px;
	font-weight: bold;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.SaveCalendar-caListPara-QShaf p {
	max-width: 100%;
	height: 20px;
	margin: 0 auto;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}
.SaveCalendar-becomeAHostSelect-r6R_X {
	background-position: 96% 7px !important;
}
.SaveCalendar-lableWeight-JD3IE {
	margin-top: 30px;
}
.SaveCalendar-calenderColorText-U6Ofo {
	display: inline-block;
	width: 20%;
	font-size: 16px;
}
.SaveCalendar-bookedWidth-tW5s2 {
	width: 14%;
	display: inline-block;
	font-size: 16px;
}
.SaveCalendar-backBtnFooter-cEkJa {
	margin-right: 30px;
}
.SaveCalendar-saveExit-eQmhc {
	color: var(--secondary-bg);
	font-size: 18px;
	cursor: pointer;
}
.SaveCalendar-notAvailableColor-UV_U8 {
	background-color: var(--becomeHost-Booked-Bg);
	height: 15px;
	width: 15px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 5px;
	margin-bottom: 5px;
	border-radius: 50%;
	position: relative;
	top: 2px;
}
.SaveCalendar-bookedColor-Yfth2 {
	background-color: var(--becomeHost-NotAvailable-Bg);
	height: 15px;
	width: 15px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 5px;
	margin-bottom: 5px;
	border-radius: 50%;
	position: relative;
	top: 2px;
}
.SaveCalendar-availableColor-Ij9UR {
	height: 15px;
	width: 15px;
	display: inline-block;
	vertical-align: middle;
	border: 1px solid var(--primary-border);
	margin-right: 5px;
	margin-bottom: 5px;
	border-radius: 50%;
	position: relative;
	top: 2px;
	background-color: var(--becomeHost-Available-Bg);
}
.SaveCalendar-specialColor-nyCKb {
	height: 15px;
	width: 15px;
	display: inline-block;
	vertical-align: middle;
	border: 1px solid var(--primary-border);
	margin-right: 5px;
	margin-bottom: 5px;
	background-color: var(--becomeHost-SpecialPrice-Bg);
	border-radius: 50%;
	position: relative;
	top: 2px;
}
.SaveCalendar-fullWidth-M6bA1 {
	width: 100% !important;
	max-width: 100% !important;
}
.SaveCalendar-noMarginMaximum-Ax0Qy {
	margin: 0px !important;
}
.SaveCalendar-maximumSpace2-IPYg3 {
	margin-bottom: 12px !important;
}
.SaveCalendar-maximumCharcter-N3u6W {
	font-size: 12px;
	padding-top: 6px;
	color: var(--primary-bg);
}
.SaveCalendar-fullWidthCalendar-vyqH7 {
	width: 100% !important;
	max-width: 1170px !important;
}
.SaveCalendar-imgSection-QQ99o {
	width: 100%;
	max-width: 28px;
	max-height: 28px;
	margin-right: 8px;
	height: auto;
}
.SaveCalendar-listIcon-HIiMt {
	display: inline-block;
	width: 28px;
	vertical-align: top;
	margin-right: 5px;
}
.SaveCalendar-listContent-ITJHT {
	display: inline-block;
	width: 85%;
	vertical-align: middle;
}
.SaveCalendar-listContentWidth-LoBne {
	width: 100% !important;
}
.SaveCalendar-listIntroContainer-D6MxM {
	width: 100%;
	max-width: 600px;
	text-align: center;
	margin: 0 auto;
}
.SaveCalendar-listIntroBgSection-nypci {
	position: relative;
	height: auto;
	min-height: 600px;
	margin-top: 36px;
}
.SaveCalendar-listIntroBg-a2dMt {
	background-position: 50% 50%;
	background-repeat: no-repeat;
	background-size: cover;
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: -1;
}
.SaveCalendar-listIntroTitle-f3M8M {
	font-size: 34px;
	font-weight: 600;
	margin: 20px auto 20px auto;
}
.SaveCalendar-profileImage-r4NoS {
	width: 72px;
	height: 72px;
	border-radius: 50%;
}
.SaveCalendar-userNameColor-ACc1O {
	color: var(--primary-bg);
}
.SaveCalendar-userDescription-TkMeg {
	font-weight: 600;
	font-size: 14px;
	color: var(--primary-foreground);
}
.SaveCalendar-userDescriptionIcon-LRRc7 {
	position: relative;
}
.SaveCalendar-userDescriptionImage-pn4YS {
	width: 100%;
}
.SaveCalendar-grid-VKkQ2 {
	display: grid;
	grid-template-columns: 50% 50%;
}
.SaveCalendar-gridTextHeight-RdfA3 {
	height: 590px;
	overflow: auto;
	padding-bottom: 80px;
}
.SaveCalendar-commonBgCss-jtm_d {
	background-repeat: no-repeat;
	background-size: cover;
	height: 100%;
	background-position: top center;
	padding: 30% 0 0 83px;
	position: relative;
}
.SaveCalendar-stepOneCommon-BK3Hk {
	font-size: 34px;
	font-weight: 600;
	position: relative;
}
.SaveCalendar-footerVector-Mr0vk {
	position: absolute;
	width: 100%;
	bottom: 0;
}
.SaveCalendar-listBannerImageSection-beDIG {
	position: relative;
	height: 100vh;
}
.SaveCalendar-listBannerImageBg-pU2qd {
	background-repeat: no-repeat;
	background-size: cover;
	height: 100%;
	width: 50%;
	background-position: top center;
	position: fixed;
	left: 0;
	right: 0;
	top: 0;
}
.SaveCalendar-listNextPosition-GCCyE {
	position: fixed;
	bottom: 0;
	width: 100%;
	background: var(--background-primary);
	z-index: 7;
	width: 100%;
	max-width: 50%;
	margin: 0px 0px 0px auto;
	right: 0px;
	left: 0px;
}
.SaveCalendar-listNextBackButton-MWN5E {
	width: 100%;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	border-top: 1px solid var(--primary-border);
	-webkit-box-shadow: 0px -7px 16px var(--primary-box-shadow);
	        box-shadow: 0px -7px 16px var(--primary-box-shadow);
	padding: 30px;
	-webkit-column-gap: 5px;
	   -moz-column-gap: 5px;
	        column-gap: 5px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	gap: 12px;
	grid-gap: 12px;
}
.SaveCalendar-listCommonDescText-tPJG7 {
	font-weight: normal;
	font-size: 16px;
	color: var(--secondary-foreground);
	max-width: 500px;
	display: block;
}
.SaveCalendar-commonListStepSection-vSEv8 {
	width: 100%;
	max-width: 452px;
	position: absolute;
	left: 83px;
	top: 23%;
	z-index: 1;
}
.SaveCalendar-displayInlineBlock-zVEk8 {
	display: inline-block;
}
.SaveCalendar-checkBoxPosition-opdUp {
	position: absolute;
	top: 38px;
	left: 0;
	right: 0;
	margin: 0 auto;
	text-align: center;
	padding: 0 10px;
}
.SaveCalendar-checkBoxOutline-H9Suy {
	position: relative;
	min-width: 190px;
	max-width: 190px;
	height: 100%;
	z-index: 2;
}
.SaveCalendar-checkoutText-UdrF9 {
	font-size: 14px;
	margin-top: 8px;
	color: var(--secondary-foreground);
}
.SaveCalendar-flex-shM4P {
	margin-top: 24px;
}
.SaveCalendar-leftSideContent-1fRd3 {
	font-size: 18px;
	border-bottom: 1px solid var(--primary-border);
	padding: 10px 0;
}
.SaveCalendar-incrementDecrementButton-H0MyY {
	width: 100%;
	border: 1px solid var(--primary-border);
	border-radius: 4px;
	display: block;
	overflow: hidden;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	height: 58px;
}
.SaveCalendar-commonTipCsss-Fiaf2 {
	color: var(--secondary-foreground);
	padding-left: 5px;
	position: relative;
	top: 2px;
}
.SaveCalendar-tipCommonCss-G7sm3 {
	margin: 12px 0 30px 0;
}
.SaveCalendar-FromTextCss-jOh7e {
	font-size: 16px;
	color: var(--secondary-foreground);
}
.SaveCalendar-sidePanelTitle-q35TU {
	font-size: 18px;
	font-weight: 600;
	margin: 20px 0 12px 0;
}
.SaveCalendar-gridFooter-FnaSO {
	display: grid;
	grid-template-columns: 50% 50%;
}
.SaveCalendar-rulesTop-tBKkO {
	margin-top: 25px;
}
.SaveCalendar-availabilityText-Co2pM {
	font-size: 34px;
	margin: 0 0 25px;
}
.SaveCalendar-calendarNoted-Dv5pA {
	font-size: 16px;
	top: 4px;
}
.SaveCalendar-guestCheckText-a6zYs {
	font-size: 16px;
}
.SaveCalendar-textBold-Pdw2_ {
	font-weight: 600;
}
.SaveCalendar-becomeHostLocationSelect-Mk_AK {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
	background-repeat: no-repeat;
	background-position: 15px 50%;
	padding-left: 35px !important;
	width: 100%;
}
.SaveCalendar-exitPageMainContent-UIrRA {
	height: 800px;
	overflow-y: auto;
}
.SaveCalendar-fullWidth-M6bA1 {
	width: 100%;
}
.SaveCalendar-waveCss-Mj8aL {
	width: 40px;
	position: relative;
	top: -4px;
}
.SaveCalendar-safetyAmenitiesFlex-DRDuf {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
	-webkit-column-gap: 25px;
	   -moz-column-gap: 25px;
	        column-gap: 25px;
}
.SaveCalendar-brandImg-QAdyE img {
	max-width: 180px;
	height: 60px;
	-o-object-fit: contain;
	   object-fit: contain;
}
.SaveCalendar-editStepLogo-HDH6d {
	margin-bottom: 20px;
}
.SaveCalendar-amenitiesCheckBoxWrapper-pzRAf {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	-webkit-box-orient: vertical;
	-webkit-box-direction: normal;
	    -ms-flex-direction: column;
	        flex-direction: column;
	border: 1px solid var(--primary-border) !important;
	padding: 12px 10px;
	border-radius: 4px;
	text-align: center;
	min-height: 140px;
	height: 100%;
	cursor: pointer;
}
.SaveCalendar-amenitiesCheckBoxWrapper-pzRAf.SaveCalendar-checked-xE1dc {
	border: 1px solid var(--secondary-bg) !important;
	background-color: var(--primary-gray-bg) !important;
}
.SaveCalendar-width100-exDxd {
	width: 100%;
}
.SaveCalendar-labelSmallText-bEhwi {
	font-size: 16px !important;
}
/* sync calendar Card box start*/
.SaveCalendar-syncCalendarCardContainer-S8CGF {
	margin-bottom: 30px;
}
.SaveCalendar-syncCalendarCard-MAUev {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: justify;
	    -ms-flex-pack: justify;
	        justify-content: space-between;
	gap: 12px;
	-webkit-box-shadow: 0px 0px 5px var(--primary-box-shadow) !important;
	        box-shadow: 0px 0px 5px var(--primary-box-shadow) !important;
	border-radius: 6px;
	padding: 12px;
	margin-bottom: 12px;
	background: transparent;
}
.SaveCalendar-syncCalendarCardBtnGrp-RwktM {
	list-style-type: none;
	padding: 0;
	margin: 0;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	-webkit-box-pack: center;
	    -ms-flex-pack: center;
	        justify-content: center;
	gap: 12px;
}
.SaveCalendar-syncCalendarCardBtn-pagsb,
.SaveCalendar-syncCalendarCardBtn-pagsb:hover,
.SaveCalendar-syncCalendarCardBtn-pagsb:focus,
.SaveCalendar-syncCalendarCardBtn-pagsb:active,
.SaveCalendar-syncCalendarCardBtn-pagsb:active:hover,
.SaveCalendar-syncCalendarCardBtn-pagsb:active:focus {
	margin: 0;
	padding: 0;
	border: none;
	background: transparent;
	outline-color: transparent;
	-webkit-box-shadow: unset;
	        box-shadow: unset;
	color: var(--primary-foreground);
}
.SaveCalendar-syncCalendarCardContainer-S8CGF .SaveCalendar-syncCalendarCard-MAUev:last-child {
	margin-bottom: 0;
}
.SaveCalendar-houseRulesList-Etd8G {
	font-size: 16px;
	font-weight: 400;
	line-height: normal;
}
/* sync calendar Card box end */
@media (max-width: 1425px) and (min-width: 1418px) {
	.SaveCalendar-flex-shM4P {
		margin-right: 13px;
	}
}
@media (max-width: 1200px) and (min-width: 768px) {
	.SaveCalendar-commonListStepSection-vSEv8 {
		left: 45px;
		padding-right: 80px;
		top: 10%;
	}

	.SaveCalendar-listNextBackButton-MWN5E {
		padding: 30px;
	}

	.SaveCalendar-landingMainContent-vJsat {
		height: auto;
		padding: 50px 25px 200px;
	}

	.SaveCalendar-listBannerImageSection-beDIG {
		height: 90vh;
	}
}
@media (max-width: 1024px) and (min-width: 768px) {
	.SaveCalendar-nextBackButton-d973p {
		width: 100%;
	}

	.SaveCalendar-nextPosition-C_QZw {
		position: fixed;
		bottom: 0;
		width: 100%;
		background: var(--background-primary);
		z-index: 4;
		padding: 0 25px 25px;
		left: 0;
		max-width: 100%;
	}

	.SaveCalendar-nextPositionMap-wvNuA {
		padding: 0 25px 25px !important;
	}

	.SaveCalendar-nextPositionCalendar-uj5eV {
		padding: 0 25px 25px !important;
	}

	.SaveCalendar-nextBackButtonMap-Ja8Z7 {
		width: 100%;
	}

	.SaveCalendar-nextBackButtonCalendar-ubKUE {
		width: 100%;
	}

	.SaveCalendar-helpPanel-C3WL1 {
		margin: 60px 13px 0;
	}

	.SaveCalendar-caListPara-QShaf {
		float: left;
		width: 70%;
		padding: 0 0 0 10px;
	}

	.SaveCalendar-calenderColorText-U6Ofo {
		width: 24%;
	}

	.SaveCalendar-bookedWidth-tW5s2 {
		width: 16%;
	}

	.SaveCalendar-listNextPosition-GCCyE {
		max-width: 50%;
	}

	.SaveCalendar-landingMainContent-vJsat {
		height: auto
	}

	.SaveCalendar-exitNextPosition-QEstY {
		max-width: 100%;
	}
}
/** SyncCalendar End **/
@media screen and (max-width: 767px) {
	.SaveCalendar-calenderColorText-U6Ofo {
		display: inline-block;
		width: 100%;
		font-size: 18px;
	}

	.SaveCalendar-bookedWidth-tW5s2 {
		width: 100% !important;
	}

	.SaveCalendar-nextBackButton-d973p {
		width: 100%;
	}

	.SaveCalendar-imagefeed-OQqoe {
		width: 100%;
		left: 0;
		top: 0;
	}

	.SaveCalendar-nextPosition-C_QZw {
		position: fixed;
		bottom: 0;
		width: 100%;
		background: var(--background-primary);
		z-index: 4;
		padding: 10px 25px 25px;
		left: 0;
	}

	.SaveCalendar-nextBackButtonMap-Ja8Z7 {
		width: 100%;
	}

	.SaveCalendar-nextBackButtonCalendar-ubKUE {
		width: 100%;
	}

	.SaveCalendar-button-_yUqu {
		margin-top: 10px;
	}

	.SaveCalendar-horizontalLineThrough-XEEJW {
		position: absolute;
		width: 100%;
		top: 0;
		left: 0;
	}

	.SaveCalendar-caListPara-QShaf {
		float: left;
		width: 70%;
		padding: 0 0 0 10px;
	}

	.SaveCalendar-imagefeed-OQqoe {
		width: 100%;
		left: 0;
		top: 0;
	}

	.SaveCalendar-landingContent-I0AiT {
		margin-top: 20px;
		padding: 0;
	}

	.SaveCalendar-landingContentTitle-_mwTX {
		font-size: 20px;
	}

	.SaveCalendar-calenderColorText-U6Ofo,
	.SaveCalendar-bookedWidth-tW5s2 {
		font-size: 14px !important;
	}

	.SaveCalendar-caListPara-QShaf {
		float: left;
		width: 70%;
		padding: 0 0 0 10px;
	}

	.SaveCalendar-grid-VKkQ2 {
		grid-template-columns: 100%;
	}

	.SaveCalendar-listNextPosition-GCCyE {
		max-width: 100%;
	}

	.SaveCalendar-backBtnFooter-cEkJa {
		margin-right: 10px;
	}

	.SaveCalendar-listNextBackButton-MWN5E {
		padding: 20px 15px 20px;
		-ms-flex-wrap: wrap;
		    flex-wrap: wrap;
	}

	.SaveCalendar-stepEditNextBtn-ER1T6 {
		-webkit-box-pack: justify;
		    -ms-flex-pack: justify;
		        justify-content: space-between;
	}

	.SaveCalendar-landingMainContent-vJsat {
		padding: 25px 20px 200px;
		height: auto;
	}

	.SaveCalendar-commonListStepSection-vSEv8 {
		max-width: 452px;
		padding: 60px 15px 60px;
	}

	.SaveCalendar-listBannerImageSection-beDIG {
		display: none;
	}

	.SaveCalendar-listContainer-J9Qgw {
		text-align: center;
		-webkit-box-pack: center;
		    -ms-flex-pack: center;
		        justify-content: center;
	}

	.SaveCalendar-availabilityText-Co2pM {
		font-size: 26px;
		margin: 25px 0 25px;
	}

	.SaveCalendar-exitPageMainContent-UIrRA {
		padding-bottom: 130px;
		height: auto;
	}

	.SaveCalendar-exitNextPosition-QEstY {
		max-width: 100%;
	}
}
@media screen and (min-width:768px) and (max-width:1024px) {
	.SaveCalendar-footerBtnFlex-pvF8h {
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
	}
}
/* ===== Coordinates Tutorial Styles ===== */
.SaveCalendar-helpSection-lWXxf {
	margin-top: 30px;
	padding: 20px;
	background-color: #f8f9fa;
	border-radius: 8px;
	border: 1px solid #e9ecef;
}
.SaveCalendar-helpTitle-eZiFU {
	font-size: 18px;
	font-weight: 600;
	margin-bottom: 15px;
	color: var(--primary-foreground);
}
.SaveCalendar-helpText-TIlpF {
	font-size: 14px;
	line-height: 1.8;
	color: #6c757d;
	margin-bottom: 20px;
}
.SaveCalendar-tutorialsContainer-x5BGY {
	display: grid;
	grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
	gap: 20px;
	margin-top: 20px;
}
.SaveCalendar-tutorialItem-TJJxE {
	background: white;
	border-radius: 8px;
	padding: 15px;
	-webkit-box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
	        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}
.SaveCalendar-tutorialSubtitle-tuGkg {
	font-size: 16px;
	font-weight: 600;
	margin-bottom: 12px;
	color: var(--primary-foreground);
}
.SaveCalendar-tutorialMediaContainer-Fmbvk {
	width: 100%;
	border-radius: 6px;
	overflow: hidden;
	background: #f8f9fa;
}
.SaveCalendar-tutorialGif-FoAh0,
.SaveCalendar-tutorialVideo-ECdCD {
	width: 100%;
	height: auto;
	display: block;
	border-radius: 6px;
}
.SaveCalendar-tutorialVideo-ECdCD {
	max-height: 400px;
}
/* Responsive tutorials */
@media (max-width: 768px) {
	.SaveCalendar-tutorialsContainer-x5BGY {
		grid-template-columns: 1fr;
	}

	.SaveCalendar-helpSection-lWXxf {
		padding: 15px;
	}

	.SaveCalendar-tutorialItem-TJJxE {
		padding: 12px;
	}
}
.SaveCalendar-saveCalendarContainer-v56T7 {
	padding: 20px 15px 45px;
	border: 1px solid var(--primary-border);
	margin-top: 90px;
	border-radius: 15px;
}
.SaveCalendar-arrowIcon-ZDjjV {
	vertical-align: middle;
	fill: rgb(72, 72, 72);
	height: 24px;
	width: 24px;
	margin: 0px 12px;
}
.SaveCalendar-loaderContainer-vwjTm {
	display: inline;
}
.SaveCalendar-landingContentTitle-_mwTX {
	margin: 0px 0px 18px 0px;
}
.SaveCalendar-floatLeftInput-ndwC0 {
	float: left;
}
.SaveCalendar-buttonLeft-otbGL {
	float: right;
	margin: 0;
	position: relative;
	top: 25px;
}
.SaveCalendar-inputHeight-ZrRFn {
	height: 43px;
	border: unset !important;
	padding: 0;

}
.SaveCalendar-aBlockWrap-cVIxa {
	overflow: hidden;
	background: var(--primary-gray-bg);
	border-radius: 26px;
}
.SaveCalendar-aBWLeft-JGPGA,
.SaveCalendar-aBWRight-K41WC {
	width: 50%;
	float: left;
}
.SaveCalendar-aBlockWrap-cVIxa .SaveCalendar-btnBg-tFuHN {
	width: 100%;
	height: 40px;
	border: 0;
	color: var(--primary-foreground);
	background: var(--primary-gray-bg);
	-webkit-box-shadow: inherit;
	        box-shadow: inherit;
}
.SaveCalendar-aBlockWrap-cVIxa .SaveCalendar-btnBg-tFuHN:hover,
.SaveCalendar-aBlockWrap-cVIxa .SaveCalendar-btnBg-tFuHN:active,
.SaveCalendar-aBlockWrap-cVIxa .SaveCalendar-btnBg-tFuHN:focus,
.SaveCalendar-aBlockWrap-cVIxa .SaveCalendar-btnBg-tFuHN.SaveCalendar-active-yl9G3 {
	background: var(--primary-bg) !important;
	color: var(--primary-btn-foreground);
	border-radius: 26px;
}
.SaveCalendar-textLeft-i14vU {
	text-align: left;
}
.SaveCalendar-sDateWrap-MMNuc {
	margin: 0px 0 10px;
}
.SaveCalendar-sDateWrap-MMNuc label {
	margin: 0;
}
.SaveCalendar-marginBottom-zSkzt {
	margin: 0;
}
.SaveCalendar-leftRadius-TubTg {
	border-radius: 26px 0 0 26px;
}
.SaveCalendar-rightRadius-qQ71u {
	border-radius: 0 26px 26px 0;
}
.SaveCalendar-saveBorder-SuDAb {
	border: 1px solid var(--primary-border);
	margin-top: 27px;
	border-radius: 6px;
}
.SaveCalendar-noMargin-y6Pe7 {
	margin: 0;
}
.SaveCalendar-borderTopspecial-AMfom {
	border-top: 1px solid var(--primary-border);
	padding: 15px 15px 5px;
}
.SaveCalendar-datesBorder-JeSat {
	padding: 15px 15px 10px;
}
.SaveCalendar-buttonRight-HOpn3 {
	float: right;
	margin-right: 26px;
	position: relative;
	top: 26px;
}
.SaveCalendar-saveBg-UxkUy {
	background: var(--primary-bg) !important;
	color: var(--primary-btn-foreground) !important;
}
@media (max-width: 1199px) {
	.SaveCalendar-saveCalendarContainer-v56T7 {
		margin-top: 18px;
	}
}
@media (min-width: 768px) and (max-width: 991px) {
	.SaveCalendar-saveCalendarContainer-v56T7 {
		padding: 10px 10px 40px 10px;
		margin-bottom: 90px;
	}

	.SaveCalendar-sDateWrap-MMNuc {
		margin: 20px 0 10px;
	}

	.SaveCalendar-sDateWrap-MMNuc h4 {
		font-size: 14px;
		margin: 0;
	}
}
@media screen and (max-width: 767px) {
	.SaveCalendar-innerCPopup-AKyLF {
		width: 100%;
	}
}
@media (max-width: 767px) and (min-width: 560px) {
	.SaveCalendar-saveCalendarContainer-v56T7 {
		width: 100%;
		max-width: 400px;
	}
}`, "",{"version":3,"sources":["webpack://./src/components/utils.css","webpack://./src/components/helpers.css","webpack://./src/components/ListPlaceStep1/ListPlaceStep1.css","webpack://./src/components/DayDragCalendar/SaveCalendar.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;ACNA;CACC,6BAA6B;AAC9B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,+BAA+B;AAChC;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,2BAA2B;AAC5B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA,0BAA0B;AAE1B;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,iCAAiC;AAClC;AAEA;CACC,kCAAkC;AACnC;AAEA;CACC,mCAAmC;AACpC;AAEA;CACC,iCAAiC;AAClC;ACzNA,iCAAiC;AAEjC;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,4BAA4B;CAC5B,YAAY;CACZ,kBAAkB;CAClB,eAAe;CACf,uCAAuC;CACvC,yCAAyC;CACzC,gCAAgC;AACjC;AAEA;CACC,eAAe;CACf,YAAY;CACZ,iBAAiB;CACjB,8CAA8C;CAC9C,sBAAsB;CACtB,4BAA4B;AAC7B;AAEA;CACC,wBAAwB;CACxB,uCAAuC;CACvC,aAAa;CACb,eAAe;CACf,kBAAkB;CAClB,YAAY;AACb;AAEA;CACC,4BAA4B;CAC5B,kBAAkB;CAClB,eAAe;CACf,uCAAuC;CACvC,yCAAyC;CACzC,gCAAgC;CAChC,eAAe;CACf,wBAAwB;CACxB,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,uHAAuH;CACvH,wGAAoH;CACpH,4CAA4C;CAC5C,4BAA4B;CAC5B,wBAAwB;CACxB,gBAAgB;CAChB,wBAAwB;AACzB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;AACvB;AAEA;CACC,aAAa;CACb,gBAAgB;AACjB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,cAAc;AACf;AAEA;CACC,eAAe;CACf,wBAAwB;AACzB;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,iBAAiB;CACjB,uBAAuB;AACxB;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,wBAAwB;CACxB,cAAc;AACf;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,gBAAgB;CAChB,qBAAqB;AACtB;AAEA;CACC,YAAY;CACZ,wBAAwB;CACxB,gBAAgB;AACjB;AAEA;CACC,0BAA0B;CAC1B,cAAc;CACd,qBAAqB;CACrB,sBAAsB;CACtB,2BAA2B;AAC5B;AAEA;CACC,WAAW;CACX,qBAAqB;CACrB,eAAe;CACf,iBAAiB;CACjB,sBAAsB;CACtB,gBAAgB;CAChB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,aAAa;CACb,6BAA6B;CAC7B,mBAAmB;AACpB;AAEA;CACC,YAAY;CACZ;AACD;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,iBAAiB;CACjB,WAAW;CACX,iBAAiB;CACjB,sBAAsB;CACtB,sBAAsB;AACvB;AAEA;CACC,kCAAkC;CAClC,eAAe;CACf,kBAAkB;CAClB,gBAAgB;AACjB;AAEA;CACC,YAAY;CACZ,qBAAqB;AACtB;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,UAAU;CACV,qBAAqB;CACrB,8BAA8B;AAC/B;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,gBAAgB;CAChB,WAAW;CACX,4BAA4B;CAC5B,kBAAkB;CAClB,eAAe;AAChB;AAEA;CACC,aAAa;CACb,gBAAgB;CAChB,uCAAuC;CACvC,aAAa;AACd;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,mBAAmB;CACnB,uCAAuC;CACvC,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,qCAAqC;AACtC;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,kCAAkC;CAClC,sBAAsB;AACvB;AAEA;CACC,kCAAkC;CAClC,cAAc;CACd,WAAW;AACZ;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;AACjB;AAEA;CACC,WAAW;CACX,UAAU;CACV,mBAAmB;CACnB,gBAAgB;CAChB,uBAAuB;CACvB,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,kCAAkC;CAClC,cAAc;CACd,sBAAsB;CACtB,mBAAmB;CACnB,mCAAmC;AACpC;AAEA;CACC,UAAU;CACV,WAAW;CACX,mCAAmC;CACnC,6BAA6B;CAC7B,kBAAkB;CAClB,kBAAkB;CAClB,YAAY;CACZ,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,0BAA0B;CAC1B,mCAAmC;AACpC;AAEA;;;CAGC,gDAAgD;CAChD,8CAA8C;CAC9C,6BAA6B;CAC7B,gBAAgB;CAChB,wBAAgB;SAAhB,gBAAgB;AACjB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,SAAS;CACT,mBAAmB;AACpB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,YAAY;AACb;AAEA;CACC,YAAY;AACb;AAEA;CACC,WAAW;AACZ;AAEA;CACC,WAAW;AACZ;AAEA;CACC,mBAAmB;CACnB,YAAY;AACb;AAEA;CACC,0BAA0B;CAC1B,wBAAwB;AACzB;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,iBAAiB;AAClB;AAEA,+BAA+B;AAE/B,oCAAoC;AAEpC;CACC,cAAc;CACd,aAAa;CACb,mCAA2B;SAA3B,2BAA2B;CAC3B,kBAAkB;CAClB,sBAAsB;CACtB,gBAAgB;CAChB,0CAA0C;CAC1C,kBAAkB;CAClB,gBAAgB;AACjB;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,OAAO;CACP,SAAS;CACT,MAAM;AACP;AAEA;CACC,YAAY;CACZ,WAAW;CACX,eAAe;AAChB;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;CACT,YAAY;CACZ,YAAY;CACZ,6BAA6B;CAC7B,gCAAgC;CAChC,eAAe;CACf,gCAAgC;CAChC,iBAAiB;AAClB;AAEA;CACC,sBAAsB;CACtB,sBAAsB;AACvB;AAEA,kCAAkC;AAElC;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,cAAc;AACf;AAEA;CACC,gBAAgB;CAChB,oBAAoB;AACrB;AAEA;CACC,YAAY;AACb;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,0BAA0B;CAC1B,wBAAwB;AACzB;AAEA;CACC,eAAe;CACf,kCAAkC;CAClC,wBAAwB;CACxB,cAAc;AACf;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,cAAc;CACd,oBAAoB;CACpB,WAAW;CACX,4BAA4B;CAC5B,kBAAkB;CAClB,eAAe;CACf,2CAA2C;CAC3C,sEAA8D;SAA9D,8DAA8D;AAC/D;AAEA;CACC,cAAc;CACd,aAAa;CACb,iBAAiB;CACjB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,iBAAiB;CACjB,cAAc;AACf;AAEA;CACC,kCAAkC;CAClC,kBAAkB;CAClB,eAAe;CACf,mBAAmB;CACnB,cAAc;AACf;AAEA;CACC,cAAc;AACf;AAEA;CACC,mBAAmB;AACpB;AAEA,yBAAyB;AAEzB;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,6BAA6B;CAC7B,WAAW;CACX,cAAc;AACf;AAEA;;;;CAIC,WAAW;CACX,2CAA2C;CAC3C,aAAa;CACb,wBAAgB;SAAhB,gBAAgB;AACjB;AAEA;CACC,YAAY;CACZ,WAAW;CACX,kCAAkC;AACnC;AAEA;CACC,eAAe;CACf,mBAAmB;CACnB,qBAAqB;CACrB,gCAAgC;CAChC,WAAW;AACZ;AAEA;CACC,2CAA2C;AAC5C;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,qBAAqB;CACrB,WAAW;CACX,eAAe;CACf,WAAW;CACX,YAAY;CACZ,gBAAgB;CAChB,yBAAiB;IAAjB,sBAAiB;KAAjB,qBAAiB;SAAjB,iBAAiB;CACjB,uBAAuB;AACxB;AAEA;;;;CAIC,WAAW;CACX,6BAA6B;CAC7B,aAAa;CACb,wBAAgB;SAAhB,gBAAgB;CAChB,0BAA0B;AAC3B;AAEA;CACC,mBAAmB;CACnB,sBAAsB;AACvB;AAEA;CACC,iBAAiB;AAClB;AAEA;CACC,0BAA0B;AAC3B;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC,kBAAkB;CAClB,WAAW;AACZ;AAEA;CACC;AACD;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,UAAU;AACX;AAEA;CACC,SAAS;AACV;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,SAAS;CACT,WAAW;CACX,qCAAqC;CACrC,UAAU;CACV,mBAAmB;CACnB,WAAW;CACX,gBAAgB;CAChB,cAAc;AACf;AAEA;CACC,2BAA2B;CAC3B,6BAA6B;CAC7B,8BAA8B;CAC9B,OAAO;CACP,QAAQ;AACT;AAEA;CACC,4BAA4B;CAC5B,6BAA6B;CAC7B,8BAA8B;CAC9B,OAAO;CACP,QAAQ;AACT;AAEA;CACC,WAAW;CACX,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,2CAA2C;CAC3C,2DAAmD;SAAnD,mDAAmD;CACnD,iBAAiB;AAClB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,WAAW;AACZ;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,UAAU;CACV,YAAY;CACZ,uCAAuC;CACvC,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;AACX;AAEA;CACC,eAAe;CACf,WAAW;CACX,YAAY;CACZ,WAAW;CACX,sBAAsB;CACtB,+BAA+B;CAC/B,kBAAkB;AACnB;AAEA;CACC,WAAW;CACX,UAAU;CACV,mBAAmB;AACpB;AAEA;CACC,SAAS;CACT,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;AAEA;CACC,eAAe;CACf,YAAY;CACZ,cAAc;CACd,4BAA4B;CAC5B,gBAAgB;CAChB,uBAAuB;CACvB,mBAAmB;AACpB;AAEA;CACC,uCAAuC;AACxC;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,eAAe;AAChB;AAEA;CACC,UAAU;CACV,qBAAqB;CACrB,eAAe;AAChB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,0BAA0B;CAC1B,eAAe;CACf,eAAe;AAChB;AAEA;CACC,6CAA6C;CAC7C,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;AACT;AAEA;CACC,mDAAmD;CACnD,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;AACT;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,sBAAsB;CACtB,uCAAuC;CACvC,iBAAiB;CACjB,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;CACR,gDAAgD;AACjD;AAEA;CACC,YAAY;CACZ,WAAW;CACX,qBAAqB;CACrB,sBAAsB;CACtB,uCAAuC;CACvC,iBAAiB;CACjB,kBAAkB;CAClB,mDAAmD;CACnD,kBAAkB;CAClB,kBAAkB;CAClB,QAAQ;AACT;AAEA;CACC,sBAAsB;CACtB,0BAA0B;AAC3B;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,8BAA8B;AAC/B;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,wBAAwB;AACzB;AAEA;CACC,sBAAsB;CACtB,4BAA4B;AAC7B;AAEA;CACC,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,iBAAiB;CACjB,YAAY;AACb;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,mBAAmB;CACnB,iBAAiB;AAClB;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;AAEA;CACC,sBAAsB;AACvB;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,cAAc;AACf;AAEA;CACC,kBAAkB;CAClB,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;AACjB;AAEA;CACC,4BAA4B;CAC5B,4BAA4B;CAC5B,sBAAsB;CACtB,kBAAkB;CAClB,OAAO;CACP,QAAQ;CACR,MAAM;CACN,WAAW;CACX,YAAY;CACZ,WAAW;AACZ;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,2BAA2B;AAC5B;AAEA;CACC,WAAW;CACX,YAAY;CACZ,kBAAkB;AACnB;AAEA;CACC,wBAAwB;AACzB;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,gCAAgC;AACjC;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;AAEA;CACC,aAAa;CACb,cAAc;CACd,oBAAoB;AACrB;AAEA;CACC,4BAA4B;CAC5B,sBAAsB;CACtB,YAAY;CACZ,+BAA+B;CAC/B,qBAAqB;CACrB,kBAAkB;AACnB;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,SAAS;AACV;AAEA;CACC,kBAAkB;CAClB,aAAa;AACd;AAEA;CACC,4BAA4B;CAC5B,sBAAsB;CACtB,YAAY;CACZ,UAAU;CACV,+BAA+B;CAC/B,eAAe;CACf,OAAO;CACP,QAAQ;CACR,MAAM;AACP;AAEA;CACC,eAAe;CACf,SAAS;CACT,WAAW;CACX,qCAAqC;CACrC,UAAU;CACV,WAAW;CACX,cAAc;CACd,wBAAwB;CACxB,UAAU;CACV,SAAS;AACV;AAEA;CACC,WAAW;CACX,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,2CAA2C;CAC3C,2DAAmD;SAAnD,mDAAmD;CACnD,aAAa;CACb,uBAAe;IAAf,oBAAe;SAAf,eAAe;CACf,mBAAe;KAAf,eAAe;CACf,SAAS;CACT,cAAc;AACf;AAEA;CACC,mBAAmB;CACnB,eAAe;CACf,kCAAkC;CAClC,gBAAgB;CAChB,cAAc;AACf;AAEA;CACC,WAAW;CACX,gBAAgB;CAChB,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,UAAU;AACX;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,QAAQ;CACR,cAAc;CACd,kBAAkB;CAClB,eAAe;AAChB;AAEA;CACC,kBAAkB;CAClB,gBAAgB;CAChB,gBAAgB;CAChB,YAAY;CACZ,UAAU;AACX;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,8CAA8C;CAC9C,eAAe;AAChB;AAEA;CACC,WAAW;CACX,uCAAuC;CACvC,kBAAkB;CAClB,cAAc;CACd,gBAAgB;CAChB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,YAAY;AACb;AAEA;CACC,kCAAkC;CAClC,iBAAiB;CACjB,kBAAkB;CAClB,QAAQ;AACT;AAEA;CACC,qBAAqB;AACtB;AAEA;CACC,eAAe;CACf,kCAAkC;AACnC;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,qBAAqB;AACtB;AAEA;CACC,aAAa;CACb,8BAA8B;AAC/B;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,QAAQ;AACT;AAEA;CACC,eAAe;AAChB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,mDAAiE;CACjE,4BAA4B;CAC5B,6BAA6B;CAC7B,6BAA6B;CAC7B,WAAW;AACZ;AAEA;CACC,aAAa;CACb,gBAAgB;AACjB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,SAAS;AACV;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,mBAAe;KAAf,eAAe;CACf,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;AACjB;AAEA;CACC,gBAAgB;CAChB,YAAY;CACZ,sBAAmB;IAAnB,mBAAmB;AACpB;AAEA;CACC,mBAAmB;AACpB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,4BAAsB;CAAtB,6BAAsB;KAAtB,0BAAsB;SAAtB,sBAAsB;CACtB,kDAAkD;CAClD,kBAAkB;CAClB,kBAAkB;CAClB,kBAAkB;CAClB,iBAAiB;CACjB,YAAY;CACZ,eAAe;AAChB;AAEA;CACC,gDAAgD;CAChD,mDAAmD;AACpD;AAEA;CACC,WAAW;AACZ;AAEA;CACC,0BAA0B;AAC3B;AAEA,gCAAgC;AAEhC;CACC,mBAAmB;AACpB;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,yBAA8B;KAA9B,sBAA8B;SAA9B,8BAA8B;CAC9B,SAAS;CACT,oEAA4D;SAA5D,4DAA4D;CAC5D,kBAAkB;CAClB,aAAa;CACb,mBAAmB;CACnB,uBAAuB;AACxB;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,SAAS;CACT,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;CACvB,SAAS;AACV;AAEA;;;;;;CAMC,SAAS;CACT,UAAU;CACV,YAAY;CACZ,uBAAuB;CACvB,0BAA0B;CAC1B,yBAAiB;SAAjB,iBAAiB;CACjB,gCAAgC;AACjC;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;AACpB;AAEA,+BAA+B;AAE/B;CACC;EACC,kBAAkB;CACnB;AACD;AAEA;CACC;EACC,UAAU;EACV,mBAAmB;EACnB,QAAQ;CACT;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,YAAY;EACZ,wBAAwB;CACzB;;CAEA;EACC,YAAY;CACb;AACD;AAEA;CACC;EACC,WAAW;CACZ;;CAEA;EACC,eAAe;EACf,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,UAAU;EACV,oBAAoB;EACpB,OAAO;EACP,eAAe;CAChB;;CAEA;EACC,+BAA+B;CAChC;;CAEA;EACC,+BAA+B;CAChC;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,UAAU;EACV,mBAAmB;CACpB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,cAAc;CACf;;CAEA;EACC;CACD;;CAEA;EACC,eAAe;CAChB;AACD;AAEA,uBAAuB;AACvB;CACC;EACC,qBAAqB;EACrB,WAAW;EACX,eAAe;CAChB;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,WAAW;EACX,OAAO;EACP,MAAM;CACP;;CAEA;EACC,eAAe;EACf,SAAS;EACT,WAAW;EACX,qCAAqC;EACrC,UAAU;EACV,uBAAuB;EACvB,OAAO;CACR;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,OAAO;CACR;;CAEA;EACC,WAAW;EACX,UAAU;EACV,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,OAAO;EACP,MAAM;CACP;;CAEA;EACC,gBAAgB;EAChB,UAAU;CACX;;CAEA;EACC,eAAe;CAChB;;CAEA;;EAEC,0BAA0B;CAC3B;;CAEA;EACC,WAAW;EACX,UAAU;EACV,mBAAmB;CACpB;;CAEA;EACC,2BAA2B;CAC5B;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,kBAAkB;CACnB;;CAEA;EACC,uBAAuB;EACvB,mBAAe;MAAf,eAAe;CAChB;;CAEA;EACC,yBAA8B;MAA9B,sBAA8B;UAA9B,8BAA8B;CAC/B;;CAEA;EACC,wBAAwB;EACxB,YAAY;CACb;;CAEA;EACC,gBAAgB;EAChB,uBAAuB;CACxB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,kBAAkB;EAClB,wBAAuB;MAAvB,qBAAuB;UAAvB,uBAAuB;CACxB;;CAEA;EACC,eAAe;EACf,mBAAmB;CACpB;;CAEA;EACC,qBAAqB;EACrB,YAAY;CACb;;CAEA;EACC,eAAe;CAChB;AACD;AAEA;CACC;EACC,oBAAa;EAAb,oBAAa;EAAb,aAAa;CACd;AACD;AAEA,4CAA4C;AAC5C;CACC,gBAAgB;CAChB,aAAa;CACb,yBAAyB;CACzB,kBAAkB;CAClB,yBAAyB;AAC1B;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,gCAAgC;AACjC;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;AAEA;CACC,aAAa;CACb,2DAA2D;CAC3D,SAAS;CACT,gBAAgB;AACjB;AAEA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,aAAa;CACb,gDAAwC;SAAxC,wCAAwC;AACzC;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,mBAAmB;CACnB,gCAAgC;AACjC;AAEA;CACC,WAAW;CACX,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;AACpB;AAEA;;CAEC,WAAW;CACX,YAAY;CACZ,cAAc;CACd,kBAAkB;AACnB;AAEA;CACC,iBAAiB;AAClB;AAEA,yBAAyB;AACzB;CACC;EACC,0BAA0B;CAC3B;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,aAAa;CACd;AACD;ACj+CA;CACC,uBAAuB;CACvB,uCAAuC;CACvC,gBAAgB;CAChB,mBAAmB;AACpB;AAEA;CACC,sBAAsB;CACtB,qBAAqB;CACrB,YAAY;CACZ,WAAW;CACX,gBAAgB;AACjB;AAEA;CACC,eAAe;AAChB;AAEA;CACC,wBAAwB;AACzB;AAEA;CACC,WAAW;AACZ;AAEA;CACC,YAAY;CACZ,SAAS;CACT,kBAAkB;CAClB,SAAS;AACV;AAEA;CACC,YAAY;CACZ,wBAAwB;CACxB,UAAU;;AAEX;AAEA;CACC,gBAAgB;CAChB,kCAAkC;CAClC,mBAAmB;AACpB;AAEA;;CAEC,UAAU;CACV,WAAW;AACZ;AAEA;CACC,WAAW;CACX,YAAY;CACZ,SAAS;CACT,gCAAgC;CAChC,kCAAkC;CAClC,2BAAmB;SAAnB,mBAAmB;AACpB;AAEA;;;;CAIC,wCAAwC;CACxC,oCAAoC;CACpC,mBAAmB;AACpB;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,kBAAkB;AACnB;AAEA;CACC,SAAS;AACV;AAEA;CACC,SAAS;AACV;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,4BAA4B;AAC7B;AAEA;CACC,uCAAuC;CACvC,gBAAgB;CAChB,kBAAkB;AACnB;AAEA;CACC,SAAS;AACV;AAEA;CACC,2CAA2C;CAC3C,sBAAsB;AACvB;AAEA;CACC,uBAAuB;AACxB;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,kBAAkB;CAClB,SAAS;AACV;AAEA;CACC,wCAAwC;CACxC,+CAA+C;AAChD;AAEA;CACC;EACC,gBAAgB;CACjB;AACD;AAEA;CACC;EACC,4BAA4B;EAC5B,mBAAmB;CACpB;;CAEA;EACC,mBAAmB;CACpB;;CAEA;EACC,eAAe;EACf,SAAS;CACV;AACD;AAEA;CACC;EACC,WAAW;CACZ;AACD;AAEA;CACC;EACC,WAAW;EACX,gBAAgB;CACjB;AACD","sourcesContent":[".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/utils.css';\n@import '../../components/helpers.css';\n\n/* Common Helpers Style - Start */\n\n.button {\n\tfont-size: 16px;\n\tmargin-top: 15px;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.formControlInput {\n\tpadding: 10px 35px 10px 10px;\n\theight: 40px;\n\tborder-radius: 4px;\n\tfont-size: 14px;\n\tborder: 1px solid var(--primary-border);\n\tbackground-color: var(--primary-input-bg);\n\tcolor: var(--primary-foreground);\n}\n\n.jumboInput {\n\tfont-size: 16px;\n\theight: 58px;\n\tpadding: 0px 20px;\n\tborder-color: var(--primary-border) !important;\n\tvertical-align: middle;\n\tborder-width: 1px !important;\n}\n\n.textareaInput {\n\theight: 230px !important;\n\tborder: solid 1px var(--primary-border);\n\tpadding: 20px;\n\tfont-size: 16px;\n\tborder-radius: 4px;\n\tresize: none;\n}\n\n.formControlSelect {\n\tpadding: 10px 32px 10px 10px;\n\tborder-radius: 4px;\n\tfont-size: 14px;\n\tborder: 1px solid var(--primary-border);\n\tbackground-color: var(--primary-input-bg);\n\tcolor: var(--primary-foreground);\n\tmax-width: 100%;\n\t/* Drop Down Caret Icon*/\n\tappearance: none;\n\tbackground-image: linear-gradient(45deg, transparent 50%, gray 50%), linear-gradient(135deg, gray 50%, transparent 50%);\n\tbackground-position: calc(100% - 20px) calc(15px + 2px), calc(100% - 15px) calc(1em + 2px), calc(100% - 2.5em) 0.5em;\n\tbackground-size: 5px 6px, 5px 6px, 1px 1.5em;\n\tbackground-repeat: no-repeat;\n\t-webkit-box-shadow: none;\n\tbox-shadow: none;\n\t/*Drop Down Caret Icon */\n}\n\n.formControlSelectLarge {\n\tmax-width: 100%;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n}\n\n.blockRadioButton {\n\tmargin-top: 0;\n\tmax-width: 320px;\n}\n\n.formSection {\n\toverflow: hidden;\n}\n\n.landingContainer {\n\tmax-width: 912px;\n\twidth: 100%;\n\tdisplay: block;\n\tmargin: 0 auto;\n}\n\n.landingTitle {\n\tfont-size: 32px;\n\tmargin: 0px 0px 30px 0px;\n}\n\n.landingStep {\n\tfont-size: 14px;\n\tcolor: var(--secondary-foreground);\n\tfont-weight: bold;\n\tmargin: 0px 0px 6px 0px;\n}\n\n.landingStep2 {\n\tfont-size: 18px;\n\tcolor: var(--secondary-foreground);\n\tmargin: 0px 0px 10px 0px;\n\tdisplay: block;\n}\n\n.landingStep3 {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n\tline-height: 1.43;\n\tfont-weight: normal;\n}\n\n.landingContent {\n\tmargin-top: 60px;\n\tpadding-bottom: 100px;\n}\n\n.landingMainContent {\n\theight: auto;\n\tpadding: 50px 45px 200px;\n\toverflow-y: auto;\n}\n\n.landingLabel {\n\tfont-size: 18px !important;\n\tdisplay: block;\n\tpadding: 0px 0px 12px;\n\tmargin: 0px !important;\n\tfont-weight: 500 !important;\n}\n\n.bookingTitle {\n\tmargin: 0px;\n\tword-wrap: break-word;\n\tfont-size: 28px;\n\tline-height: 36px;\n\tletter-spacing: -0.6px;\n\tpadding-top: 2px;\n\tpadding-bottom: 2px;\n}\n\n.bookText {\n\tfont-size: 16px;\n\tfont-weight: normal;\n}\n\n.radioInput {\n\tposition: relative;\n\theight: 1.25em;\n\twidth: 1.25em;\n\tmargin-right: 10px !important;\n\tvertical-align: top;\n}\n\n.radioSize {\n\theight: 15px;\n\twidth: 15px\n}\n\n.checkboxLabel {\n\tfont-weight: normal;\n\tdisplay: inline;\n\tpadding: 0px 10px;\n\tmargin: 0px;\n\tline-height: 20px;\n\tvertical-align: middle;\n\tword-break: break-word;\n}\n\n.landingCaption {\n\tcolor: var(--secondary-foreground);\n\tfont-size: 16px;\n\tmargin-bottom: 5px;\n\tmargin-top: 30px;\n}\n\n.listContainer {\n\tpadding: 0px;\n\tlist-style-type: none;\n}\n\n.listContent {\n\tmargin-bottom: 30px;\n\tfont-size: 16px;\n\twidth: 50%;\n\tdisplay: inline-block;\n\tvertical-align: top !important;\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tz-index: 1;\n\tdisplay: block;\n\tmargin: 15px 0px;\n\twidth: 100%;\n\tcolor: var(--primary-border);\n\ttext-align: center;\n\tfont-size: 14px;\n}\n\n.blockRadioButton {\n\tmargin-top: 0;\n\tmax-width: 320px;\n\tborder: 1px solid var(--primary-border);\n\tpadding: 20px;\n}\n\n.blockRadioButton:first-of-type {\n\tborder-radius: 3px 3px 3px 3px;\n}\n\n.blockRadioButton:last-of-type {\n\tborder-radius: 0px 0px 3px 3px;\n}\n\n.blockRadioButton:not(:last-of-type) {\n\tborder-bottom: 0px;\n}\n\n.helpPanelContainer {\n\tmax-width: 320px;\n}\n\n.helpPanel {\n\tmargin: 60px 30px 0;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 4px;\n\twidth: 100%;\n\tpadding: 26px;\n\tbackground: var(--background-primary);\n}\n\n.helpPanelText {\n\tfont-size: 16px;\n\tline-height: 150%;\n\tcolor: var(--secondary-foreground);\n\tword-break: break-word;\n}\n\n.helpPanelTextTitle {\n\tcolor: var(--secondary-foreground);\n\tdisplay: block;\n\twidth: 100%;\n}\n\n.incrementDecrementButton {\n\tmax-width: 320px;\n\twidth: 100%;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 2px;\n\tdisplay: block;\n\toverflow: hidden;\n}\n\n.incrementDecrementText {\n\tfloat: left;\n\twidth: 80%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tpadding: 18px 20px;\n\tmargin: 0px;\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n\tline-height: 1;\n\tvertical-align: middle;\n\tfont-weight: normal;\n\tbackground: var(--primary-input-bg);\n}\n\n.iconButton {\n\twidth: 10%;\n\tfloat: left;\n\tborder-color: var(--primary-border);\n\tborder-width: 0px 0px 0px 1px;\n\tborder-radius: 0px;\n\tpadding: 12px 20px;\n\theight: 65px;\n\tmargin: 0px 0px;\n\tfont-size: 15px;\n\tline-height: 1px;\n\tcolor: var(--secondary-bg);\n\tbackground: var(--primary-input-bg);\n}\n\n.iconButton:hover,\n.iconButton:focus,\n.iconButton:active {\n\tbackground: var(--background-primary) !important;\n\tborder-color: var(--primary-border) !important;\n\tborder-width: 0px 0px 0px 1px;\n\tmargin-left: 0px;\n\tbox-shadow: none;\n}\n\n.checkBoxSection {\n\tdisplay: table-cell;\n}\n\n.checkBoxWidth {\n\twidth: 1%;\n\tvertical-align: top;\n}\n\n.checkBoxImage {\n\twidth: 36px;\n}\n\n.checkBoxLabel {\n\tpadding: 0px 10px;\n}\n\n.textAlignRight {\n\ttext-align: right;\n}\n\n.textAlignLeft {\n\ttext-align: left;\n}\n\n.textAlignCenter {\n\ttext-align: center;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.pullRight {\n\tfloat: right;\n}\n\n.pullLeft {\n\tfloat: left;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\n.unorderedList li {\n\tmargin-bottom: 10px;\n\tpadding: 0px;\n}\n\n.checkIcon {\n\tcolor: var(--secondary-bg);\n\tmargin: 0px 10px 5px 0px;\n}\n\n.textHigh {\n\tfont-size: 18px;\n\tline-height: 1.43;\n}\n\n.textLow {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n\tline-height: 1.43;\n}\n\n/* Common Helpers Style - End */\n\n/** List Photo Cover Style - Start */\n\n.listPhotoCover {\n\tdisplay: block;\n\theight: 185px;\n\tbackface-visibility: hidden;\n\tposition: relative;\n\tvertical-align: bottom;\n\toverflow: hidden;\n\tbackground-color: var(--secondary-gray-bg);\n\ttext-align: center;\n\tmargin-top: 15px;\n}\n\n.listPhotoMedia {\n\tposition: absolute;\n\tright: 0;\n\tleft: 0;\n\tbottom: 0;\n\ttop: 0;\n}\n\n.imgResponsive {\n\theight: 100%;\n\twidth: auto;\n\tmax-width: 100%;\n}\n\n.coverPhotoSelection {\n\tposition: absolute;\n\tbottom: 5px;\n\tleft: 5px;\n\twidth: 100px;\n\theight: 30px;\n\tbackground: var(--primary-bg);\n\tcolor: var(--primary-foreground);\n\tfont-size: 14px;\n\tborder-radius: 5px 12px 12px 5px;\n\tline-height: 30px;\n}\n\n.coverPhotoCheckbox {\n\tmargin: 0px !important;\n\tvertical-align: middle;\n}\n\n/** List Photo Cover Style - End */\n\n.landingContainer {\n\tmax-width: 912px;\n\twidth: 100%;\n\tdisplay: block;\n\tmargin: 0 auto;\n}\n\n.landingContent {\n\tmargin-top: 60px;\n\tmargin-bottom: 100px;\n}\n\n.noPadding {\n\tpadding: 0px;\n}\n\n.landingContentTitle {\n\tfont-size: 18px;\n\tmargin: 0 0 12px;\n\tposition: relative;\n}\n\n.landingSaftyTitle {\n\tfont-size: 20px !important;\n\tmargin: 0px 0px 18px 0px;\n}\n\n.bookingLandingStep {\n\tfont-size: 18px;\n\tcolor: var(--secondary-foreground);\n\tmargin: 0px 0px 10px 0px;\n\tdisplay: block;\n}\n\n.horizontalLineThrough {\n\tposition: relative;\n\tz-index: 0;\n\tdisplay: block;\n\tmargin: 0px 0px 15px;\n\twidth: 100%;\n\tcolor: var(--primary-border);\n\ttext-align: center;\n\tfont-size: 14px;\n\tborder-top: 1px solid var(--primary-border);\n\tbox-shadow: 0px -2px 10px var(--primary-box-shadow) !important;\n}\n\n.BookingradioInput {\n\theight: 1.25em;\n\twidth: 1.25em;\n\tmargin-right: 5px;\n\tvertical-align: top;\n}\n\n.bookText {\n\tfont-size: 16px;\n\tfont-weight: normal;\n\tmargin-left: 10px;\n\tdisplay: block;\n}\n\n.subText {\n\tcolor: var(--secondary-foreground);\n\tpadding-left: 10px;\n\tfont-size: 14px;\n\tfont-weight: normal;\n\tdisplay: block;\n}\n\n.displayTable {\n\tdisplay: table;\n}\n\n.displayTableCell {\n\tdisplay: table-cell;\n}\n\n/** SyncCalendar Start **/\n\n.listType {\n\tpadding-left: 0;\n\tlist-style: none;\n}\n\n.iconContainer {\n\tcursor: pointer;\n\tbackground-color: transparent;\n\tborder: 0px;\n\tdisplay: block;\n}\n\n.iconContainer:active,\n.iconContainer:focus,\n.iconContainer:hover,\n.iconContainer:active:focus {\n\tborder: 0px;\n\tbackground-color: var(--background-primary);\n\toutline: none;\n\tbox-shadow: none;\n}\n\n.iconSize {\n\theight: 20px;\n\twidth: 20px;\n\tcolor: var(--secondary-foreground);\n}\n\n.calenderText {\n\tfont-size: 16px;\n\tline-height: normal;\n\tword-wrap: break-word;\n\tcolor: var(--primary-foreground);\n\tmargin: 0px;\n}\n\n.LineColor {\n\tborder-top: 1px solid var(--primary-border);\n}\n\n.btnContainer {\n\tcolor: var(--secondary-bg);\n\tfont-size: 18px;\n\ttext-decoration: none;\n\tborder: 0px;\n\tcursor: pointer;\n\tmargin: 0px;\n\tpadding: 0px;\n\ttext-align: left;\n\tuser-select: auto;\n\tbackground: transparent;\n}\n\n.btnContainer:hover,\n.btnContainer:focus,\n.btnContainer:active,\n.btnContainer:active:focus {\n\tborder: 0px;\n\tbackground-color: transparent;\n\toutline: none;\n\tbox-shadow: none;\n\tcolor: var(--secondary-bg);\n}\n\n.displayTableCellVertical {\n\tdisplay: table-cell;\n\tvertical-align: middle;\n}\n\n.paddingLeft {\n\tpadding-left: 8px;\n}\n\n.iconColor {\n\tcolor: var(--secondary-bg);\n}\n\n.space0 {\n\tmargin-bottom: 0px;\n}\n\n.step3IconLeft {\n\tdisplay: inline-block;\n}\n\n.displayTableRow {\n\tdisplay: table-row;\n\twidth: 100%;\n}\n\n.displayTableCellWidth {\n\twidth: 5%\n}\n\n.displayTableCellTop {\n\tvertical-align: top;\n}\n\n.tableWidthTwo {\n\twidth: 80%;\n}\n\n.tableWidth {\n\twidth: 5%;\n}\n\n.noFontWeight {\n\tfont-weight: normal;\n}\n\n.nextPosition {\n\tposition: fixed;\n\tbottom: 0;\n\twidth: 100%;\n\tbackground: var(--background-primary);\n\tz-index: 4;\n\tpadding: 0 0px 25px;\n\twidth: 100%;\n\tmax-width: 644px;\n\tmargin: 0 auto;\n}\n\n.nextPositionMap {\n\tmax-width: 912px !important;\n\tpadding-left: 15px !important;\n\tpadding-right: 15px !important;\n\tleft: 0;\n\tright: 0;\n}\n\n.nextPositionCalendar {\n\tmax-width: 1170px !important;\n\tpadding-left: 15px !important;\n\tpadding-right: 15px !important;\n\tleft: 0;\n\tright: 0;\n}\n\n.nextBackButton {\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tborder-top: 1px solid var(--primary-border);\n\tbox-shadow: 0px -7px 16px var(--primary-box-shadow);\n\tpadding-top: 30px;\n}\n\n.nextBackButtonMap {\n\twidth: 100%;\n}\n\n.nextBackButtonCalendar {\n\twidth: 100%;\n}\n\n.posRelative {\n\tposition: relative;\n}\n\n.imagefeed {\n\tposition: absolute;\n\ttop: 20px;\n\twidth: 30%;\n\theight: 50px;\n\tborder: 1px solid var(--primary-border);\n\tpadding: 7px 7px;\n\tborder-radius: 5px;\n\tz-index: 3;\n}\n\n.caListimg {\n\tmax-width: 55px;\n\twidth: 100%;\n\theight: 35px;\n\tfloat: left;\n\tbackground-size: cover;\n\tbackground-position: top center;\n\tborder-radius: 2px;\n}\n\n.caListPara {\n\tfloat: left;\n\twidth: 78%;\n\tpadding: 0 0 0 10px;\n}\n\n.caListPara h2 {\n\tmargin: 0;\n\tfont-size: 14px;\n\tfont-weight: bold;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.caListPara p {\n\tmax-width: 100%;\n\theight: 20px;\n\tmargin: 0 auto;\n\t-webkit-box-orient: vertical;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n}\n\n.becomeAHostSelect {\n\tbackground-position: 96% 7px !important;\n}\n\n.lableWeight {\n\tmargin-top: 30px;\n}\n\n.calenderColorText {\n\tdisplay: inline-block;\n\twidth: 20%;\n\tfont-size: 16px;\n}\n\n.bookedWidth {\n\twidth: 14%;\n\tdisplay: inline-block;\n\tfont-size: 16px;\n}\n\n.backBtnFooter {\n\tmargin-right: 30px;\n}\n\n.saveExit {\n\tcolor: var(--secondary-bg);\n\tfont-size: 18px;\n\tcursor: pointer;\n}\n\n.notAvailableColor {\n\tbackground-color: var(--becomeHost-Booked-Bg);\n\theight: 15px;\n\twidth: 15px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 5px;\n\tmargin-bottom: 5px;\n\tborder-radius: 50%;\n\tposition: relative;\n\ttop: 2px;\n}\n\n.bookedColor {\n\tbackground-color: var(--becomeHost-NotAvailable-Bg);\n\theight: 15px;\n\twidth: 15px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 5px;\n\tmargin-bottom: 5px;\n\tborder-radius: 50%;\n\tposition: relative;\n\ttop: 2px;\n}\n\n.availableColor {\n\theight: 15px;\n\twidth: 15px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tborder: 1px solid var(--primary-border);\n\tmargin-right: 5px;\n\tmargin-bottom: 5px;\n\tborder-radius: 50%;\n\tposition: relative;\n\ttop: 2px;\n\tbackground-color: var(--becomeHost-Available-Bg);\n}\n\n.specialColor {\n\theight: 15px;\n\twidth: 15px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tborder: 1px solid var(--primary-border);\n\tmargin-right: 5px;\n\tmargin-bottom: 5px;\n\tbackground-color: var(--becomeHost-SpecialPrice-Bg);\n\tborder-radius: 50%;\n\tposition: relative;\n\ttop: 2px;\n}\n\n.fullWidth {\n\twidth: 100% !important;\n\tmax-width: 100% !important;\n}\n\n.noMarginMaximum {\n\tmargin: 0px !important;\n}\n\n.maximumSpace2 {\n\tmargin-bottom: 12px !important;\n}\n\n.maximumCharcter {\n\tfont-size: 12px;\n\tpadding-top: 6px;\n\tcolor: var(--primary-bg);\n}\n\n.fullWidthCalendar {\n\twidth: 100% !important;\n\tmax-width: 1170px !important;\n}\n\n.imgSection {\n\twidth: 100%;\n\tmax-width: 28px;\n\tmax-height: 28px;\n\tmargin-right: 8px;\n\theight: auto;\n}\n\n.listIcon {\n\tdisplay: inline-block;\n\twidth: 28px;\n\tvertical-align: top;\n\tmargin-right: 5px;\n}\n\n.listContent {\n\tdisplay: inline-block;\n\twidth: 85%;\n\tvertical-align: middle;\n}\n\n.listContentWidth {\n\twidth: 100% !important;\n}\n\n.listIntroContainer {\n\twidth: 100%;\n\tmax-width: 600px;\n\ttext-align: center;\n\tmargin: 0 auto;\n}\n\n.listIntroBgSection {\n\tposition: relative;\n\theight: auto;\n\tmin-height: 600px;\n\tmargin-top: 36px;\n}\n\n.listIntroBg {\n\tbackground-position: 50% 50%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\twidth: 100%;\n\theight: 100%;\n\tz-index: -1;\n}\n\n.listIntroTitle {\n\tfont-size: 34px;\n\tfont-weight: 600;\n\tmargin: 20px auto 20px auto;\n}\n\n.profileImage {\n\twidth: 72px;\n\theight: 72px;\n\tborder-radius: 50%;\n}\n\n.userNameColor {\n\tcolor: var(--primary-bg);\n}\n\n.userDescription {\n\tfont-weight: 600;\n\tfont-size: 14px;\n\tcolor: var(--primary-foreground);\n}\n\n.userDescriptionIcon {\n\tposition: relative;\n}\n\n.userDescriptionImage {\n\twidth: 100%;\n}\n\n.grid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n}\n\n.gridTextHeight {\n\theight: 590px;\n\toverflow: auto;\n\tpadding-bottom: 80px;\n}\n\n.commonBgCss {\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\theight: 100%;\n\tbackground-position: top center;\n\tpadding: 30% 0 0 83px;\n\tposition: relative;\n}\n\n.stepOneCommon {\n\tfont-size: 34px;\n\tfont-weight: 600;\n\tposition: relative;\n}\n\n.footerVector {\n\tposition: absolute;\n\twidth: 100%;\n\tbottom: 0;\n}\n\n.listBannerImageSection {\n\tposition: relative;\n\theight: 100vh;\n}\n\n.listBannerImageBg {\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n\theight: 100%;\n\twidth: 50%;\n\tbackground-position: top center;\n\tposition: fixed;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n}\n\n.listNextPosition {\n\tposition: fixed;\n\tbottom: 0;\n\twidth: 100%;\n\tbackground: var(--background-primary);\n\tz-index: 7;\n\twidth: 100%;\n\tmax-width: 50%;\n\tmargin: 0px 0px 0px auto;\n\tright: 0px;\n\tleft: 0px;\n}\n\n.listNextBackButton {\n\twidth: 100%;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tborder-top: 1px solid var(--primary-border);\n\tbox-shadow: 0px -7px 16px var(--primary-box-shadow);\n\tpadding: 30px;\n\tcolumn-gap: 5px;\n\tflex-wrap: wrap;\n\tgap: 12px;\n\tgrid-gap: 12px;\n}\n\n.listCommonDescText {\n\tfont-weight: normal;\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n\tmax-width: 500px;\n\tdisplay: block;\n}\n\n.commonListStepSection {\n\twidth: 100%;\n\tmax-width: 452px;\n\tposition: absolute;\n\tleft: 83px;\n\ttop: 23%;\n\tz-index: 1;\n}\n\n.displayInlineBlock {\n\tdisplay: inline-block;\n}\n\n.checkBoxPosition {\n\tposition: absolute;\n\ttop: 38px;\n\tleft: 0;\n\tright: 0;\n\tmargin: 0 auto;\n\ttext-align: center;\n\tpadding: 0 10px;\n}\n\n.checkBoxOutline {\n\tposition: relative;\n\tmin-width: 190px;\n\tmax-width: 190px;\n\theight: 100%;\n\tz-index: 2;\n}\n\n.checkoutText {\n\tfont-size: 14px;\n\tmargin-top: 8px;\n\tcolor: var(--secondary-foreground);\n}\n\n.flex {\n\tmargin-top: 24px;\n}\n\n.leftSideContent {\n\tfont-size: 18px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tpadding: 10px 0;\n}\n\n.incrementDecrementButton {\n\twidth: 100%;\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 4px;\n\tdisplay: block;\n\toverflow: hidden;\n\tdisplay: flex;\n\theight: 58px;\n}\n\n.commonTipCsss {\n\tcolor: var(--secondary-foreground);\n\tpadding-left: 5px;\n\tposition: relative;\n\ttop: 2px;\n}\n\n.tipCommonCss {\n\tmargin: 12px 0 30px 0;\n}\n\n.FromTextCss {\n\tfont-size: 16px;\n\tcolor: var(--secondary-foreground);\n}\n\n.sidePanelTitle {\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tmargin: 20px 0 12px 0;\n}\n\n.gridFooter {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n}\n\n.rulesTop {\n\tmargin-top: 25px;\n}\n\n.availabilityText {\n\tfont-size: 34px;\n\tmargin: 0 0 25px;\n}\n\n.calendarNoted {\n\tfont-size: 16px;\n\ttop: 4px;\n}\n\n.guestCheckText {\n\tfont-size: 16px;\n}\n\n.textBold {\n\tfont-weight: 600;\n}\n\n.becomeHostLocationSelect {\n\tbackground: url('../../../public/SiteIcons/listLocatiionPin.svg');\n\tbackground-repeat: no-repeat;\n\tbackground-position: 15px 50%;\n\tpadding-left: 35px !important;\n\twidth: 100%;\n}\n\n.exitPageMainContent {\n\theight: 800px;\n\toverflow-y: auto;\n}\n\n.fullWidth {\n\twidth: 100%;\n}\n\n.waveCss {\n\twidth: 40px;\n\tposition: relative;\n\ttop: -4px;\n}\n\n.safetyAmenitiesFlex {\n\tdisplay: flex;\n\tflex-wrap: wrap;\n\tcolumn-gap: 25px;\n}\n\n.brandImg img {\n\tmax-width: 180px;\n\theight: 60px;\n\tobject-fit: contain;\n}\n\n.editStepLogo {\n\tmargin-bottom: 20px;\n}\n\n.amenitiesCheckBoxWrapper {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tflex-direction: column;\n\tborder: 1px solid var(--primary-border) !important;\n\tpadding: 12px 10px;\n\tborder-radius: 4px;\n\ttext-align: center;\n\tmin-height: 140px;\n\theight: 100%;\n\tcursor: pointer;\n}\n\n.amenitiesCheckBoxWrapper.checked {\n\tborder: 1px solid var(--secondary-bg) !important;\n\tbackground-color: var(--primary-gray-bg) !important;\n}\n\n.width100 {\n\twidth: 100%;\n}\n\n.labelSmallText {\n\tfont-size: 16px !important;\n}\n\n/* sync calendar Card box start*/\n\n.syncCalendarCardContainer {\n\tmargin-bottom: 30px;\n}\n\n.syncCalendarCard {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 12px;\n\tbox-shadow: 0px 0px 5px var(--primary-box-shadow) !important;\n\tborder-radius: 6px;\n\tpadding: 12px;\n\tmargin-bottom: 12px;\n\tbackground: transparent;\n}\n\n.syncCalendarCardBtnGrp {\n\tlist-style-type: none;\n\tpadding: 0;\n\tmargin: 0;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 12px;\n}\n\n.syncCalendarCardBtn,\n.syncCalendarCardBtn:hover,\n.syncCalendarCardBtn:focus,\n.syncCalendarCardBtn:active,\n.syncCalendarCardBtn:active:hover,\n.syncCalendarCardBtn:active:focus {\n\tmargin: 0;\n\tpadding: 0;\n\tborder: none;\n\tbackground: transparent;\n\toutline-color: transparent;\n\tbox-shadow: unset;\n\tcolor: var(--primary-foreground);\n}\n\n.syncCalendarCardContainer .syncCalendarCard:last-child {\n\tmargin-bottom: 0;\n}\n\n.houseRulesList {\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tline-height: normal;\n}\n\n/* sync calendar Card box end */\n\n@media (max-width: 1425px) and (min-width: 1418px) {\n\t.flex {\n\t\tmargin-right: 13px;\n\t}\n}\n\n@media (max-width: 1200px) and (min-width: 768px) {\n\t.commonListStepSection {\n\t\tleft: 45px;\n\t\tpadding-right: 80px;\n\t\ttop: 10%;\n\t}\n\n\t.listNextBackButton {\n\t\tpadding: 30px;\n\t}\n\n\t.landingMainContent {\n\t\theight: auto;\n\t\tpadding: 50px 25px 200px;\n\t}\n\n\t.listBannerImageSection {\n\t\theight: 90vh;\n\t}\n}\n\n@media (max-width: 1024px) and (min-width: 768px) {\n\t.nextBackButton {\n\t\twidth: 100%;\n\t}\n\n\t.nextPosition {\n\t\tposition: fixed;\n\t\tbottom: 0;\n\t\twidth: 100%;\n\t\tbackground: var(--background-primary);\n\t\tz-index: 4;\n\t\tpadding: 0 25px 25px;\n\t\tleft: 0;\n\t\tmax-width: 100%;\n\t}\n\n\t.nextPositionMap {\n\t\tpadding: 0 25px 25px !important;\n\t}\n\n\t.nextPositionCalendar {\n\t\tpadding: 0 25px 25px !important;\n\t}\n\n\t.nextBackButtonMap {\n\t\twidth: 100%;\n\t}\n\n\t.nextBackButtonCalendar {\n\t\twidth: 100%;\n\t}\n\n\t.helpPanel {\n\t\tmargin: 60px 13px 0;\n\t}\n\n\t.caListPara {\n\t\tfloat: left;\n\t\twidth: 70%;\n\t\tpadding: 0 0 0 10px;\n\t}\n\n\t.calenderColorText {\n\t\twidth: 24%;\n\t}\n\n\t.bookedWidth {\n\t\twidth: 16%;\n\t}\n\n\t.listNextPosition {\n\t\tmax-width: 50%;\n\t}\n\n\t.landingMainContent {\n\t\theight: auto\n\t}\n\n\t.exitNextPosition {\n\t\tmax-width: 100%;\n\t}\n}\n\n/** SyncCalendar End **/\n@media screen and (max-width: 767px) {\n\t.calenderColorText {\n\t\tdisplay: inline-block;\n\t\twidth: 100%;\n\t\tfont-size: 18px;\n\t}\n\n\t.bookedWidth {\n\t\twidth: 100% !important;\n\t}\n\n\t.nextBackButton {\n\t\twidth: 100%;\n\t}\n\n\t.imagefeed {\n\t\twidth: 100%;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n\n\t.nextPosition {\n\t\tposition: fixed;\n\t\tbottom: 0;\n\t\twidth: 100%;\n\t\tbackground: var(--background-primary);\n\t\tz-index: 4;\n\t\tpadding: 10px 25px 25px;\n\t\tleft: 0;\n\t}\n\n\t.nextBackButtonMap {\n\t\twidth: 100%;\n\t}\n\n\t.nextBackButtonCalendar {\n\t\twidth: 100%;\n\t}\n\n\t.button {\n\t\tmargin-top: 10px;\n\t}\n\n\t.horizontalLineThrough {\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\ttop: 0;\n\t\tleft: 0;\n\t}\n\n\t.caListPara {\n\t\tfloat: left;\n\t\twidth: 70%;\n\t\tpadding: 0 0 0 10px;\n\t}\n\n\t.imagefeed {\n\t\twidth: 100%;\n\t\tleft: 0;\n\t\ttop: 0;\n\t}\n\n\t.landingContent {\n\t\tmargin-top: 20px;\n\t\tpadding: 0;\n\t}\n\n\t.landingContentTitle {\n\t\tfont-size: 20px;\n\t}\n\n\t.calenderColorText,\n\t.bookedWidth {\n\t\tfont-size: 14px !important;\n\t}\n\n\t.caListPara {\n\t\tfloat: left;\n\t\twidth: 70%;\n\t\tpadding: 0 0 0 10px;\n\t}\n\n\t.grid {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.listNextPosition {\n\t\tmax-width: 100%;\n\t}\n\n\t.backBtnFooter {\n\t\tmargin-right: 10px;\n\t}\n\n\t.listNextBackButton {\n\t\tpadding: 20px 15px 20px;\n\t\tflex-wrap: wrap;\n\t}\n\n\t.stepEditNextBtn {\n\t\tjustify-content: space-between;\n\t}\n\n\t.landingMainContent {\n\t\tpadding: 25px 20px 200px;\n\t\theight: auto;\n\t}\n\n\t.commonListStepSection {\n\t\tmax-width: 452px;\n\t\tpadding: 60px 15px 60px;\n\t}\n\n\t.listBannerImageSection {\n\t\tdisplay: none;\n\t}\n\n\t.listContainer {\n\t\ttext-align: center;\n\t\tjustify-content: center;\n\t}\n\n\t.availabilityText {\n\t\tfont-size: 26px;\n\t\tmargin: 25px 0 25px;\n\t}\n\n\t.exitPageMainContent {\n\t\tpadding-bottom: 130px;\n\t\theight: auto;\n\t}\n\n\t.exitNextPosition {\n\t\tmax-width: 100%;\n\t}\n}\n\n@media screen and (min-width:768px) and (max-width:1024px) {\n\t.footerBtnFlex {\n\t\tdisplay: flex;\n\t}\n}\n\n/* ===== Coordinates Tutorial Styles ===== */\n.helpSection {\n\tmargin-top: 30px;\n\tpadding: 20px;\n\tbackground-color: #f8f9fa;\n\tborder-radius: 8px;\n\tborder: 1px solid #e9ecef;\n}\n\n.helpTitle {\n\tfont-size: 18px;\n\tfont-weight: 600;\n\tmargin-bottom: 15px;\n\tcolor: var(--primary-foreground);\n}\n\n.helpText {\n\tfont-size: 14px;\n\tline-height: 1.8;\n\tcolor: #6c757d;\n\tmargin-bottom: 20px;\n}\n\n.tutorialsContainer {\n\tdisplay: grid;\n\tgrid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n\tgap: 20px;\n\tmargin-top: 20px;\n}\n\n.tutorialItem {\n\tbackground: white;\n\tborder-radius: 8px;\n\tpadding: 15px;\n\tbox-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.tutorialSubtitle {\n\tfont-size: 16px;\n\tfont-weight: 600;\n\tmargin-bottom: 12px;\n\tcolor: var(--primary-foreground);\n}\n\n.tutorialMediaContainer {\n\twidth: 100%;\n\tborder-radius: 6px;\n\toverflow: hidden;\n\tbackground: #f8f9fa;\n}\n\n.tutorialGif,\n.tutorialVideo {\n\twidth: 100%;\n\theight: auto;\n\tdisplay: block;\n\tborder-radius: 6px;\n}\n\n.tutorialVideo {\n\tmax-height: 400px;\n}\n\n/* Responsive tutorials */\n@media (max-width: 768px) {\n\t.tutorialsContainer {\n\t\tgrid-template-columns: 1fr;\n\t}\n\n\t.helpSection {\n\t\tpadding: 15px;\n\t}\n\n\t.tutorialItem {\n\t\tpadding: 12px;\n\t}\n}","@import '../ListPlaceStep1/ListPlaceStep1.css';\n@import '../../components/utils.css';\n\n.saveCalendarContainer {\n\tpadding: 20px 15px 45px;\n\tborder: 1px solid var(--primary-border);\n\tmargin-top: 90px;\n\tborder-radius: 15px;\n}\n\n.arrowIcon {\n\tvertical-align: middle;\n\tfill: rgb(72, 72, 72);\n\theight: 24px;\n\twidth: 24px;\n\tmargin: 0px 12px;\n}\n\n.loaderContainer {\n\tdisplay: inline;\n}\n\n.landingContentTitle {\n\tmargin: 0px 0px 18px 0px;\n}\n\n.floatLeftInput {\n\tfloat: left;\n}\n\n.buttonLeft {\n\tfloat: right;\n\tmargin: 0;\n\tposition: relative;\n\ttop: 25px;\n}\n\n.inputHeight {\n\theight: 43px;\n\tborder: unset !important;\n\tpadding: 0;\n\n}\n\n.aBlockWrap {\n\toverflow: hidden;\n\tbackground: var(--primary-gray-bg);\n\tborder-radius: 26px;\n}\n\n.aBWLeft,\n.aBWRight {\n\twidth: 50%;\n\tfloat: left;\n}\n\n.aBlockWrap .btnBg {\n\twidth: 100%;\n\theight: 40px;\n\tborder: 0;\n\tcolor: var(--primary-foreground);\n\tbackground: var(--primary-gray-bg);\n\tbox-shadow: inherit;\n}\n\n.aBlockWrap .btnBg:hover,\n.aBlockWrap .btnBg:active,\n.aBlockWrap .btnBg:focus,\n.aBlockWrap .btnBg.active {\n\tbackground: var(--primary-bg) !important;\n\tcolor: var(--primary-btn-foreground);\n\tborder-radius: 26px;\n}\n\n.textLeft {\n\ttext-align: left;\n}\n\n.sDateWrap {\n\tmargin: 0px 0 10px;\n}\n\n.sDateWrap label {\n\tmargin: 0;\n}\n\n.marginBottom {\n\tmargin: 0;\n}\n\n.leftRadius {\n\tborder-radius: 26px 0 0 26px;\n}\n\n.rightRadius {\n\tborder-radius: 0 26px 26px 0;\n}\n\n.saveBorder {\n\tborder: 1px solid var(--primary-border);\n\tmargin-top: 27px;\n\tborder-radius: 6px;\n}\n\n.noMargin {\n\tmargin: 0;\n}\n\n.borderTopspecial {\n\tborder-top: 1px solid var(--primary-border);\n\tpadding: 15px 15px 5px;\n}\n\n.datesBorder {\n\tpadding: 15px 15px 10px;\n}\n\n.buttonRight {\n\tfloat: right;\n\tmargin-right: 26px;\n\tposition: relative;\n\ttop: 26px;\n}\n\n.saveBg {\n\tbackground: var(--primary-bg) !important;\n\tcolor: var(--primary-btn-foreground) !important;\n}\n\n@media (max-width: 1199px) {\n\t.saveCalendarContainer {\n\t\tmargin-top: 18px;\n\t}\n}\n\n@media (min-width: 768px) and (max-width: 991px) {\n\t.saveCalendarContainer {\n\t\tpadding: 10px 10px 40px 10px;\n\t\tmargin-bottom: 90px;\n\t}\n\n\t.sDateWrap {\n\t\tmargin: 20px 0 10px;\n\t}\n\n\t.sDateWrap h4 {\n\t\tfont-size: 14px;\n\t\tmargin: 0;\n\t}\n}\n\n@media screen and (max-width: 767px) {\n\t.innerCPopup {\n\t\twidth: 100%;\n\t}\n}\n\n@media (max-width: 767px) and (min-width: 560px) {\n\t.saveCalendarContainer {\n\t\twidth: 100%;\n\t\tmax-width: 400px;\n\t}\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `SaveCalendar-errorMessage-gKG3f`,
	"space1": `SaveCalendar-space1-tD9QG`,
	"space2": `SaveCalendar-space2-EyXsY`,
	"space3": `SaveCalendar-space3-d4EYA`,
	"space4": `SaveCalendar-space4-z9fue`,
	"space5": `SaveCalendar-space5-l9CPK`,
	"space6": `SaveCalendar-space6-ulQEm`,
	"space7": `SaveCalendar-space7-tgDI9`,
	"spaceTop8": `SaveCalendar-spaceTop8-WpJKF`,
	"spaceTop1": `SaveCalendar-spaceTop1-c9EzL`,
	"spaceTop2": `SaveCalendar-spaceTop2-cosGs`,
	"spaceTop3": `SaveCalendar-spaceTop3-n3jRv`,
	"spaceTop4": `SaveCalendar-spaceTop4-k0Qgg`,
	"spaceTop5": `SaveCalendar-spaceTop5-diYPC`,
	"spaceTop6": `SaveCalendar-spaceTop6-vWoAo`,
	"spaceTop7": `SaveCalendar-spaceTop7-xFwZW`,
	"noMargin": `SaveCalendar-noMargin-y6Pe7`,
	"padding1": `SaveCalendar-padding1-H5qkr`,
	"padding2": `SaveCalendar-padding2-JIhcD`,
	"padding3": `SaveCalendar-padding3-w8VYr`,
	"padding4": `SaveCalendar-padding4-Cad9j`,
	"padding5": `SaveCalendar-padding5-fH28s`,
	"padding6": `SaveCalendar-padding6-vIgKg`,
	"padding7": `SaveCalendar-padding7-pGled`,
	"paddingTop1": `SaveCalendar-paddingTop1-oAaEI`,
	"paddingTop2": `SaveCalendar-paddingTop2-hqyKk`,
	"paddingTop3": `SaveCalendar-paddingTop3-M6Pqm`,
	"paddingTop4": `SaveCalendar-paddingTop4-CvtpU`,
	"paddingTop5": `SaveCalendar-paddingTop5-tR2fT`,
	"paddingTop6": `SaveCalendar-paddingTop6-FbF5b`,
	"paddingTop7": `SaveCalendar-paddingTop7-B2RWU`,
	"noPadding": `SaveCalendar-noPadding-nt7Pt`,
	"textBold": `SaveCalendar-textBold-Pdw2_`,
	"textBolder": `SaveCalendar-textBolder-N1aIw`,
	"textNormal": `SaveCalendar-textNormal-TB4OB`,
	"spaceBottom20": `SaveCalendar-spaceBottom20-sewfH`,
	"spaceBottom10": `SaveCalendar-spaceBottom10-LYSTT`,
	"marginNone": `SaveCalendar-marginNone-x2C2d`,
	"spaceBottom15": `SaveCalendar-spaceBottom15-yShX5`,
	"marginTopNone": `SaveCalendar-marginTopNone-mOMuo`,
	"spaceTop11": `SaveCalendar-spaceTop11-fNFRq`,
	"spaceTop21": `SaveCalendar-spaceTop21-Cc6Wy`,
	"spaceTop20": `SaveCalendar-spaceTop20-n7IcT`,
	"spaceTop10": `SaveCalendar-spaceTop10-Ti7n7`,
	"textDarkBlue": `SaveCalendar-textDarkBlue-mcQhN`,
	"textLightBlue": `SaveCalendar-textLightBlue-ZFVM8`,
	"textLightSandleGreen": `SaveCalendar-textLightSandleGreen-mjtY4`,
	"textLightBrown": `SaveCalendar-textLightBrown-AoxRY`,
	"textMediumMaroon": `SaveCalendar-textMediumMaroon-F8zRS`,
	"textBrown": `SaveCalendar-textBrown-A4_v4`,
	"textMaroon": `SaveCalendar-textMaroon-ifcnX`,
	"textDarkBrown": `SaveCalendar-textDarkBrown-PxfPQ`,
	"textMediumBrown": `SaveCalendar-textMediumBrown-_CZB1`,
	"textSkyBlue": `SaveCalendar-textSkyBlue-Mu6P8`,
	"textGray": `SaveCalendar-textGray-qsq4b`,
	"button": `SaveCalendar-button-_yUqu`,
	"formGroup": `SaveCalendar-formGroup-tkqSn`,
	"formControlInput": `SaveCalendar-formControlInput-ebrXk`,
	"jumboInput": `SaveCalendar-jumboInput-TOnxx`,
	"textareaInput": `SaveCalendar-textareaInput-fOy3M`,
	"formControlSelect": `SaveCalendar-formControlSelect-ERpb5`,
	"formControlSelectLarge": `SaveCalendar-formControlSelectLarge-msXQI`,
	"select": `SaveCalendar-select-Vnfiy`,
	"blockRadioButton": `SaveCalendar-blockRadioButton-u1CC8`,
	"formSection": `SaveCalendar-formSection-F_35J`,
	"landingContainer": `SaveCalendar-landingContainer-autrm`,
	"landingTitle": `SaveCalendar-landingTitle-kXPXZ`,
	"landingStep": `SaveCalendar-landingStep-TVbfs`,
	"landingStep2": `SaveCalendar-landingStep2-oVtJx`,
	"landingStep3": `SaveCalendar-landingStep3-ia8O6`,
	"landingContent": `SaveCalendar-landingContent-I0AiT`,
	"landingMainContent": `SaveCalendar-landingMainContent-vJsat`,
	"landingLabel": `SaveCalendar-landingLabel-W9uOO`,
	"bookingTitle": `SaveCalendar-bookingTitle-oaAAA`,
	"bookText": `SaveCalendar-bookText-hja0z`,
	"radioInput": `SaveCalendar-radioInput-hNQmy`,
	"radioSize": `SaveCalendar-radioSize-HwcKn`,
	"checkboxLabel": `SaveCalendar-checkboxLabel-mLPg5`,
	"landingCaption": `SaveCalendar-landingCaption-Fa2Kl`,
	"listContainer": `SaveCalendar-listContainer-J9Qgw`,
	"listContent": `SaveCalendar-listContent-ITJHT`,
	"horizontalLineThrough": `SaveCalendar-horizontalLineThrough-XEEJW`,
	"helpPanelContainer": `SaveCalendar-helpPanelContainer-bWkJM`,
	"helpPanel": `SaveCalendar-helpPanel-C3WL1`,
	"helpPanelText": `SaveCalendar-helpPanelText-dKIaH`,
	"helpPanelTextTitle": `SaveCalendar-helpPanelTextTitle-LYDgS`,
	"incrementDecrementButton": `SaveCalendar-incrementDecrementButton-H0MyY`,
	"incrementDecrementText": `SaveCalendar-incrementDecrementText-VpMxG`,
	"iconButton": `SaveCalendar-iconButton-LDa5F`,
	"checkBoxSection": `SaveCalendar-checkBoxSection-SlS_9`,
	"checkBoxWidth": `SaveCalendar-checkBoxWidth-IlPlw`,
	"checkBoxImage": `SaveCalendar-checkBoxImage-Wphrf`,
	"checkBoxLabel": `SaveCalendar-checkBoxLabel-Qh_9K`,
	"textAlignRight": `SaveCalendar-textAlignRight-vayZQ`,
	"textAlignLeft": `SaveCalendar-textAlignLeft-PBOq0`,
	"textAlignCenter": `SaveCalendar-textAlignCenter-VH_vs`,
	"pullRight": `SaveCalendar-pullRight-sB9Sl`,
	"pullLeft": `SaveCalendar-pullLeft-kbRmH`,
	"unorderedList": `SaveCalendar-unorderedList-wgMv_`,
	"checkIcon": `SaveCalendar-checkIcon-NWwyk`,
	"textHigh": `SaveCalendar-textHigh-PhyNU`,
	"textLow": `SaveCalendar-textLow-vNGDw`,
	"listPhotoCover": `SaveCalendar-listPhotoCover-uJ1tw`,
	"listPhotoMedia": `SaveCalendar-listPhotoMedia-t8sGw`,
	"imgResponsive": `SaveCalendar-imgResponsive-QgUuo`,
	"coverPhotoSelection": `SaveCalendar-coverPhotoSelection-KBkds`,
	"coverPhotoCheckbox": `SaveCalendar-coverPhotoCheckbox-vc8JZ`,
	"landingContentTitle": `SaveCalendar-landingContentTitle-_mwTX`,
	"landingSaftyTitle": `SaveCalendar-landingSaftyTitle-RA4gQ`,
	"bookingLandingStep": `SaveCalendar-bookingLandingStep-GJ76s`,
	"BookingradioInput": `SaveCalendar-BookingradioInput-L0Lf0`,
	"subText": `SaveCalendar-subText-tz5w8`,
	"displayTable": `SaveCalendar-displayTable-eb_7w`,
	"displayTableCell": `SaveCalendar-displayTableCell-GjAwt`,
	"listType": `SaveCalendar-listType-D3HVJ`,
	"iconContainer": `SaveCalendar-iconContainer-vzFiT`,
	"iconSize": `SaveCalendar-iconSize-jxfut`,
	"calenderText": `SaveCalendar-calenderText-j8o6u`,
	"LineColor": `SaveCalendar-LineColor-jQwgJ`,
	"btnContainer": `SaveCalendar-btnContainer-_nvcV`,
	"displayTableCellVertical": `SaveCalendar-displayTableCellVertical-yBViW`,
	"paddingLeft": `SaveCalendar-paddingLeft-njBEy`,
	"iconColor": `SaveCalendar-iconColor-ZXS9N`,
	"space0": `SaveCalendar-space0-M4krK`,
	"step3IconLeft": `SaveCalendar-step3IconLeft-cCsy5`,
	"displayTableRow": `SaveCalendar-displayTableRow-OZ814`,
	"displayTableCellWidth": `SaveCalendar-displayTableCellWidth-oAJm7`,
	"displayTableCellTop": `SaveCalendar-displayTableCellTop-Yw1o_`,
	"tableWidthTwo": `SaveCalendar-tableWidthTwo-xNcC4`,
	"tableWidth": `SaveCalendar-tableWidth-SdQx5`,
	"noFontWeight": `SaveCalendar-noFontWeight-MngMG`,
	"nextPosition": `SaveCalendar-nextPosition-C_QZw`,
	"nextPositionMap": `SaveCalendar-nextPositionMap-wvNuA`,
	"nextPositionCalendar": `SaveCalendar-nextPositionCalendar-uj5eV`,
	"nextBackButton": `SaveCalendar-nextBackButton-d973p`,
	"nextBackButtonMap": `SaveCalendar-nextBackButtonMap-Ja8Z7`,
	"nextBackButtonCalendar": `SaveCalendar-nextBackButtonCalendar-ubKUE`,
	"posRelative": `SaveCalendar-posRelative-cm2dK`,
	"imagefeed": `SaveCalendar-imagefeed-OQqoe`,
	"caListimg": `SaveCalendar-caListimg-q_Ec2`,
	"caListPara": `SaveCalendar-caListPara-QShaf`,
	"becomeAHostSelect": `SaveCalendar-becomeAHostSelect-r6R_X`,
	"lableWeight": `SaveCalendar-lableWeight-JD3IE`,
	"calenderColorText": `SaveCalendar-calenderColorText-U6Ofo`,
	"bookedWidth": `SaveCalendar-bookedWidth-tW5s2`,
	"backBtnFooter": `SaveCalendar-backBtnFooter-cEkJa`,
	"saveExit": `SaveCalendar-saveExit-eQmhc`,
	"notAvailableColor": `SaveCalendar-notAvailableColor-UV_U8`,
	"bookedColor": `SaveCalendar-bookedColor-Yfth2`,
	"availableColor": `SaveCalendar-availableColor-Ij9UR`,
	"specialColor": `SaveCalendar-specialColor-nyCKb`,
	"fullWidth": `SaveCalendar-fullWidth-M6bA1`,
	"noMarginMaximum": `SaveCalendar-noMarginMaximum-Ax0Qy`,
	"maximumSpace2": `SaveCalendar-maximumSpace2-IPYg3`,
	"maximumCharcter": `SaveCalendar-maximumCharcter-N3u6W`,
	"fullWidthCalendar": `SaveCalendar-fullWidthCalendar-vyqH7`,
	"imgSection": `SaveCalendar-imgSection-QQ99o`,
	"listIcon": `SaveCalendar-listIcon-HIiMt`,
	"listContentWidth": `SaveCalendar-listContentWidth-LoBne`,
	"listIntroContainer": `SaveCalendar-listIntroContainer-D6MxM`,
	"listIntroBgSection": `SaveCalendar-listIntroBgSection-nypci`,
	"listIntroBg": `SaveCalendar-listIntroBg-a2dMt`,
	"listIntroTitle": `SaveCalendar-listIntroTitle-f3M8M`,
	"profileImage": `SaveCalendar-profileImage-r4NoS`,
	"userNameColor": `SaveCalendar-userNameColor-ACc1O`,
	"userDescription": `SaveCalendar-userDescription-TkMeg`,
	"userDescriptionIcon": `SaveCalendar-userDescriptionIcon-LRRc7`,
	"userDescriptionImage": `SaveCalendar-userDescriptionImage-pn4YS`,
	"grid": `SaveCalendar-grid-VKkQ2`,
	"gridTextHeight": `SaveCalendar-gridTextHeight-RdfA3`,
	"commonBgCss": `SaveCalendar-commonBgCss-jtm_d`,
	"stepOneCommon": `SaveCalendar-stepOneCommon-BK3Hk`,
	"footerVector": `SaveCalendar-footerVector-Mr0vk`,
	"listBannerImageSection": `SaveCalendar-listBannerImageSection-beDIG`,
	"listBannerImageBg": `SaveCalendar-listBannerImageBg-pU2qd`,
	"listNextPosition": `SaveCalendar-listNextPosition-GCCyE`,
	"listNextBackButton": `SaveCalendar-listNextBackButton-MWN5E`,
	"listCommonDescText": `SaveCalendar-listCommonDescText-tPJG7`,
	"commonListStepSection": `SaveCalendar-commonListStepSection-vSEv8`,
	"displayInlineBlock": `SaveCalendar-displayInlineBlock-zVEk8`,
	"checkBoxPosition": `SaveCalendar-checkBoxPosition-opdUp`,
	"checkBoxOutline": `SaveCalendar-checkBoxOutline-H9Suy`,
	"checkoutText": `SaveCalendar-checkoutText-UdrF9`,
	"flex": `SaveCalendar-flex-shM4P`,
	"leftSideContent": `SaveCalendar-leftSideContent-1fRd3`,
	"commonTipCsss": `SaveCalendar-commonTipCsss-Fiaf2`,
	"tipCommonCss": `SaveCalendar-tipCommonCss-G7sm3`,
	"FromTextCss": `SaveCalendar-FromTextCss-jOh7e`,
	"sidePanelTitle": `SaveCalendar-sidePanelTitle-q35TU`,
	"gridFooter": `SaveCalendar-gridFooter-FnaSO`,
	"rulesTop": `SaveCalendar-rulesTop-tBKkO`,
	"availabilityText": `SaveCalendar-availabilityText-Co2pM`,
	"calendarNoted": `SaveCalendar-calendarNoted-Dv5pA`,
	"guestCheckText": `SaveCalendar-guestCheckText-a6zYs`,
	"becomeHostLocationSelect": `SaveCalendar-becomeHostLocationSelect-Mk_AK`,
	"exitPageMainContent": `SaveCalendar-exitPageMainContent-UIrRA`,
	"waveCss": `SaveCalendar-waveCss-Mj8aL`,
	"safetyAmenitiesFlex": `SaveCalendar-safetyAmenitiesFlex-DRDuf`,
	"brandImg": `SaveCalendar-brandImg-QAdyE`,
	"editStepLogo": `SaveCalendar-editStepLogo-HDH6d`,
	"amenitiesCheckBoxWrapper": `SaveCalendar-amenitiesCheckBoxWrapper-pzRAf`,
	"checked": `SaveCalendar-checked-xE1dc`,
	"width100": `SaveCalendar-width100-exDxd`,
	"labelSmallText": `SaveCalendar-labelSmallText-bEhwi`,
	"syncCalendarCardContainer": `SaveCalendar-syncCalendarCardContainer-S8CGF`,
	"syncCalendarCard": `SaveCalendar-syncCalendarCard-MAUev`,
	"syncCalendarCardBtnGrp": `SaveCalendar-syncCalendarCardBtnGrp-RwktM`,
	"syncCalendarCardBtn": `SaveCalendar-syncCalendarCardBtn-pagsb`,
	"houseRulesList": `SaveCalendar-houseRulesList-Etd8G`,
	"exitNextPosition": `SaveCalendar-exitNextPosition-QEstY`,
	"stepEditNextBtn": `SaveCalendar-stepEditNextBtn-ER1T6`,
	"footerBtnFlex": `SaveCalendar-footerBtnFlex-pvF8h`,
	"helpSection": `SaveCalendar-helpSection-lWXxf`,
	"helpTitle": `SaveCalendar-helpTitle-eZiFU`,
	"helpText": `SaveCalendar-helpText-TIlpF`,
	"tutorialsContainer": `SaveCalendar-tutorialsContainer-x5BGY`,
	"tutorialItem": `SaveCalendar-tutorialItem-TJJxE`,
	"tutorialSubtitle": `SaveCalendar-tutorialSubtitle-tuGkg`,
	"tutorialMediaContainer": `SaveCalendar-tutorialMediaContainer-Fmbvk`,
	"tutorialGif": `SaveCalendar-tutorialGif-FoAh0`,
	"tutorialVideo": `SaveCalendar-tutorialVideo-ECdCD`,
	"saveCalendarContainer": `SaveCalendar-saveCalendarContainer-v56T7`,
	"arrowIcon": `SaveCalendar-arrowIcon-ZDjjV`,
	"loaderContainer": `SaveCalendar-loaderContainer-vwjTm`,
	"floatLeftInput": `SaveCalendar-floatLeftInput-ndwC0`,
	"buttonLeft": `SaveCalendar-buttonLeft-otbGL`,
	"inputHeight": `SaveCalendar-inputHeight-ZrRFn`,
	"aBlockWrap": `SaveCalendar-aBlockWrap-cVIxa`,
	"aBWLeft": `SaveCalendar-aBWLeft-JGPGA`,
	"aBWRight": `SaveCalendar-aBWRight-K41WC`,
	"btnBg": `SaveCalendar-btnBg-tFuHN`,
	"active": `SaveCalendar-active-yl9G3`,
	"textLeft": `SaveCalendar-textLeft-i14vU`,
	"sDateWrap": `SaveCalendar-sDateWrap-MMNuc`,
	"marginBottom": `SaveCalendar-marginBottom-zSkzt`,
	"leftRadius": `SaveCalendar-leftRadius-TubTg`,
	"rightRadius": `SaveCalendar-rightRadius-qQ71u`,
	"saveBorder": `SaveCalendar-saveBorder-SuDAb`,
	"borderTopspecial": `SaveCalendar-borderTopspecial-AMfom`,
	"datesBorder": `SaveCalendar-datesBorder-JeSat`,
	"buttonRight": `SaveCalendar-buttonRight-HOpn3`,
	"saveBg": `SaveCalendar-saveBg-UxkUy`,
	"innerCPopup": `SaveCalendar-innerCPopup-AKyLF`
};
module.exports = ___CSS_LOADER_EXPORT___;
